/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import { connect } from "react-redux";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from "../../configs/const";
import * as depositWithdrawalService from "../../services/depositWithdrawalService";
import * as accountServices from "../../services/accountService";
import {
  PAYINOUTMANUALNUMBERDEPOSIT,
  PAYINOUTMANUALNUMBERWITHDRAWAL,
  PAYINOUTMANUALNUMBERSUPPORT,
  SOCIALMEDIALINKS,
} from "../../configs/apkFileName";
import * as xoroService from "../../services/xoroService";
import Toast from "./toast";
import { DEPOSIT_MQR_DEMO_BTN, DEPOSIT_MQR_TIMER_SEC, DepositBonusOffers, DepositBonusOffersDefault, DepositBonusOffersInfoPopup, MINIMUM_DEPOSIT, MINIMUM_WITHDRAW, NonXoroPeDepositSupportNumber, WithdrawInfoPopup, WithdrawPreviousBank } from "../../configs/B2C.config";
import { displayName } from "react-widgets/lib/Calendar";
import html2canvas from 'html2canvas';
import QRCode from "react-qr-code";
import WithdrawBankDropdownMenu from "./withdrawBankDropdownMenu"

let mqrQRTimer = null;
class Depositpopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      depositSelected: 1,
      userId: "",
      operatorId: "",
      amount: 0,
      emailId: "",
      mobileNumber: "",
      balance: 0,
      accountHolderName: "",
      accountNumber: "",
      iFSCCode: "",
      paymentMode: "Bank",
      upiType: "Gpay",
      walletName: "",
      walletNumber: "",
      curPaymentType: "",
      curAccount: {},
      xoroData: {},
      loading: true,
      xoroAmount: '',
      utr: null,
      ss: {},
      showToast: false,
      toastMsg: "",
      toastType: "",
      buttonLoader: false,
      xoroDataWithDrawal: [],
      currentWithdrawalType: '',
      mqrImgDt: '',
      upiDirectButtonLink: {},
      receiptID: '',
      mqrtimerseconds: 0,
      mqrtimerdisplay: '',
      xoropeDataLoaded: false,
      previousBankDetails: null,
      previousBankDetailsBtnLdr: false,
      availableBonusOffers: null,
      bonusOfferApplied: false,
      ifscBankDetails: null
    };
    this.selectFile = this.selectFile.bind(this);
    this.captureScreenshot = this.captureScreenshot.bind(this);
    this.shareImage = this.shareImage.bind(this);
  }

  captureScreenshot() {
    const element = document.getElementById('screenshotElement'); // ID of the component to capture
    html2canvas(element).then(canvas => {
      const screenshot = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = screenshot;
      link.download = `screenshot${this.state.receiptID}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  async shareImage(imageSrc) {
    try {
      const imageTitle = 'Payment Code';
      const response = await fetch(imageSrc);
      const blob = await response.blob();
      const file = new File([blob], imageTitle, { type: blob.type });
      const data = {
        title: `${imageTitle} - ${this.state.receiptID}`,
        text: 'Please find the payment code for the transaction.',
        files: [file],
      };
      if (navigator.share) {
        navigator.share(data)
          .then(() => console.log('Image shared successfully'))
          .catch((error) => console.error('Error sharing image', error));
      } else {
        console.log('Web Share API not supported');
      }
    } catch (err) {
      console.log(err.name, err.message);
    }
  }

  async componentDidMount() {
    const self = this;
    this.getBalance();
    let profData = JSON.parse(localStorage.getItem('profData'));
    if(WithdrawPreviousBank){
      this.getMyPreviousBankDetails(profData);
    }
    if(DepositBonusOffers){
      this.getDepositBonusOffersDetails(profData.operatorId)
    }
    xoroService.getXoroActiveProviderData().then((res) => {
      if (!!res && res.isSuccess) {
        res.data['payment_mode'] = {};
        self.setState({ xoroData: res.data, xoropeDataLoaded:false}, () => {
          // if (res.data.gatewayVendor === "XOROPE") {
            let profData = JSON.parse(localStorage.getItem('profData'));
             
            let body = {
              "operatorId": profData?.operatorId,
              "parents": profData?.parents?.reverse()
            }
            xoroService.getXoroData(body).then((res) => {
              if (!!res && res.isSuccess) {
                localStorage.setItem("xoroData", JSON.stringify(res.data));
                let xrDataObj = this.state.xoroData;
                xrDataObj['payment_mode'] = res.data;
                self.setState({ xoroData: xrDataObj}, () => {//, xoropeDataLoaded: true 
                  // if (res.data.gatewayVendor === "XOROPE") {
                    let paymentTypes = Object.keys(res.data).filter(
                      (pm, i) => {
                        return res.data[pm].length > 0;
                      }
                      );
                  if(paymentTypes.length>0){
                    let mqr = paymentTypes.indexOf('mqr');
                    let whtsapp = paymentTypes.indexOf('whatsapp');
                    // if(whtsapp > -1){
                    //   window.open(`https://wa.me/+${res.data[paymentTypes[whtsapp]][0].mobile_number}`, "_blank");
                    //   self.props.hidePopup()
                    // } else {
                      self.setState({ curPaymentType: paymentTypes[whtsapp > -1 ? whtsapp : (mqr > -1 ? mqr : 0)], xoropeDataLoaded: true }, () => {
                        self.setState({
                          curAccount: res.data[paymentTypes[whtsapp > -1 ? whtsapp : (mqr > -1 ? mqr : 0)]][0],
                          loading: false
                        });
                      });
                    // }
                  } else {
                    self.setState({loading: false});
                  }
                  // }
                });
              } else {
                self.setState({loading:false})
                self.props.notify(res.exception.message, "error");
              }
            });
          // } else {
          //   self.setState({loading:false})
          // }
        });
      } else {
        self.props.notify(res.exception.message, "error");
      }
      // if (!!res && res.isSuccess) {

      // } else {
      //   self.props.notify(res.exception.message, "error");
      // }
    });

    xoroService.getManualWithdrawal().then((res) => {
      if (!!res && res.isSuccess) {
        let xoroDataWithDrwl = res.data;
        if (!!xoroDataWithDrwl.operatorId) {
          delete xoroDataWithDrwl.operatorId;
        }
        Object.keys(xoroDataWithDrwl).forEach((key) => {
          if (!xoroDataWithDrwl[key]) {
            delete xoroDataWithDrwl[key];
          }
        });
        let xrDtWthDrwl = Object.keys(xoroDataWithDrwl);
        localStorage.setItem("xoroDataWithDrawal", JSON.stringify(xrDtWthDrwl));
        self.setState({ xoroDataWithDrawal: xrDtWthDrwl, currentWithdrawalType: (xrDtWthDrwl.length > 0 ? (xrDtWthDrwl.includes('bank') ? 'bank' : xrDtWthDrwl[0]) : '')});
      } else {
        self.props.notify(res.exception.message, "error");
      }
    });

  }

  getMyPreviousBankDetails(profData){
    const self = this;
    let body = {oid: profData.operatorId, user: profData.username};
    xoroService.getMyPreviousBank(body).then((res) => {
      if (!!res && res.isSuccess) {
        if(!!res.data){
          self.setState({previousBankDetails: res.data});
        }
      } else {
        self.props.notify(res.exception.message, "error");
      }
    });
  }

  getDepositBonusOffersDetails(oid){
    const self = this;
    xoroService.getDepositBonusOffers(oid).then((res) => {
      if (!!res && res.isSuccess) {
        if(!!res.data){
          self.setState({availableBonusOffers: res.data.percentage, bonusOfferApplied: (DepositBonusOffersDefault ? (!!res.data.percentage && res.data.percentage !== 0) : false)});
        }
      } else {
        self.props.notify(res.exception.message, "error");
      }
    });
  }

  

  getIFSCCodeDetailsFromCode(ifsccode){
    const self = this;
    this.setState({
      ifscBankDetails:null
    },()=>{
      xoroService.getIFSCCodeDetails(ifsccode).then((res) => {
        if (!!res) {
          self.setState({ifscBankDetails: res});
        }
      });
    })
  }

  componentWillUnmount() {
    clearInterval(mqrQRTimer);
  }
  selectFile(e) {
    let imgData = {
      currentFile: e.target.files[0],
      previewImage: URL.createObjectURL(e.target.files[0]),
      progress: 0,
      message: "",
    };
    this.setState({ ss: imgData });
  }
  submitPayment() {
    const self = this;
    let frmData = new FormData();
    let cp = this.state.curPaymentType;
    if (
      this.state.xoroAmount === null ||
      this.state.xoroAmount === 0 ||
      this.state.xoroAmount === ""
    ) {
      this.showToast("Please enter amount", "error");
      return false;
    } else if (this.state.xoroAmount < MINIMUM_DEPOSIT) {
      this.showToast(`Please enter min amount of ${MINIMUM_DEPOSIT}.`, "error");
      return false;
    } else if (
      (this.state.utr === null || this.state.utr === "") &&
      this.state.curPaymentType !== "cash"
    ) {
      this.showToast("Please enter UTR number", "error");
      return false;
    } else if (this.state.utr.length !== 12 && !["cash", "crypto", "nagad", "bkash", "rocket", "upay"].includes(this.state.curPaymentType)) {
      this.showToast(
        "Invalid UTR number. Please enter 12 digit UTR number",
        "error"
      );
      return false;
    } else if (
      (!this.state.ss.currentFile || this.state.ss.currentFile === null) &&
      this.state.curPaymentType !== "cash"
    ) {
      this.showToast("Please upload payment screen-shot", "error");
      return false;
    }
    frmData.append("operator_id", this.state.curAccount.operator_id);
    frmData.append("username", this.state.userId);
    frmData.append("amount", this.state.xoroAmount);
    frmData.append("utr_number", this.state.utr);
    frmData.append("ss_file", this.state.ss.currentFile);
    frmData.append("email", this.state.emailId);
    frmData.append("mobile", this.state.mobileNumber);
    frmData.append(
      "account_name",
      this.state.curPaymentType === "bank_account"
        ? this.state.curAccount.account_holder_name
        : this.state.curPaymentType === "crypto"
          ? this.state.curAccount.crypto_name
          : this.state.curPaymentType === "cash"
            ? "cash"
            : this.state.curAccount.name
    );
    frmData.append(
      "account_id",
      this.state.curPaymentType === "bank_account"
        ? this.state.curAccount.account_number
        : this.state.curPaymentType === "crypto"
          ? this.state.curAccount.crypto_address
          : this.state.curPaymentType === "cash"
            ? "cash"
            : this.state.curAccount.upi_id
    );
    frmData.append(
      "payment_mode",
      cp === "phonepe"
        ? "PhonePe"
        : cp === "googlepay"
          ? "GooglePay"
          : cp === "paytm"
            ? "Paytm"
            : cp === "upi"
              ? "Upi"
              : cp === "bank_account"
                ? "Bank"
                : cp === "crypto"
                  ? "Crypto"
                  : cp === "rocket"
                    ? "Rocket"
                    : cp === "upay"
                      ? "Upay"
                      : cp === "bkash"
                        ? "Bkash"
                        : cp === "nagad"
                          ? "Nagad"
                          : "Cash"
    );
    frmData.append("applied_bonus", this.state.bonusOfferApplied)
    frmData.append("bonus_percentage", this.state.bonusOfferApplied && !!this.state.availableBonusOffers ? this.state.availableBonusOffers : 0)
    this.setState({ buttonLoader: true }, () => {
      xoroService.postManualPayment(frmData).then((res) => {
        if (!!res && res.isSuccess) {
          self.props.MySwal.fire({
            title: 'Success.',
            text: res.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              self.props.hidePopup();
            }
          })


          self.setState(
            { xoroAmount: '', ss: {}, utr: "", buttonLoader: false },
            () => {
              if (!!document.getElementById("exampleFormControlFile1")) {
                document.getElementById("exampleFormControlFile1").value = "";
              }
            }
          );
        } else {
          self.setState({ buttonLoader: false });
          self.props.notify(res.exception.message, "error");
        }
      });
    });
  }
  showToast(msg, type) {
    let self = this;
    this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
      setTimeout(() => {
        self.setState({ toastMsg: "", toastType: "", showToast: false });
      }, 3000);
    });
  }
  getBalance() {
    accountServices.getProfileData(this.state.uid).then((res) => {
      let profData = res;
      let userData = profData;
      profData = JSON.stringify(profData);
      localStorage.setItem("profData", profData);

      // let userData = localStorage.getItem('profData')
      if (!!profData) {
        let bal = parseFloat(userData.availableBalance);
        if (!!userData.exposure) {
          bal = bal + parseFloat(userData.exposure);
        }
        if (!!userData.upLineBalance) {
          bal = bal + parseFloat(userData.upLineBalance);
        }
        this.setState({
          userId: userData.username,
          operatorId: userData.operatorId,
          emailId: userData.email,
          mobileNumber: userData.mobile,
          balance: bal.toFixed(2),
          operatorId: userData.operatorId,
        });
      }
    });
  }
  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }
  onDepositClick() {
    const self = this;
    if (this.state.amount < MINIMUM_DEPOSIT) {
      this.props.notify(`Minimum deposit amount is ${MINIMUM_DEPOSIT}`, "warning");
      return false;
    }
    let body = {
      operatorId: this.state.operatorId,
      username: this.state.userId,
      amount: this.state.amount,
      appliedBonus: this.state.bonusOfferApplied,
      bonusPercentage: this.state.bonusOfferApplied && !!this.state.availableBonusOffers ? this.state.availableBonusOffers : 0
    };
    // "email" : this.state.emailId,
    // "mobile" : this.state.mobileNumber,
    // "returnUrl": window.origin + "/transactionStatus/" orderId
    depositWithdrawalService
      .depositOrder(body)
      .then((res) => {
        if (!!res) {
          if (!!res.orderId) {
            window.location.href = res.url;
          } else {
            self.props.notify(
              `${res.exception.code} ${res.exception.message}`,
              "error"
            );
            self.props.hidePopup();
          }
        }
      })
      .catch((error) => {
        self.props.notify(error, "error");
      });
  }
  validateWithdrawalForm() {
    let returnval = true;
    if (this.state.currentWithdrawalType === "bank") {
      returnval =
        !!this.state.accountHolderName &&
          this.state.accountHolderName.length > 1 &&
          !!this.state.accountNumber &&
          this.state.accountNumber.length > 4 &&
          !!this.state.iFSCCode &&
          this.state.iFSCCode.length > 9 &&
          !!this.state.amount &&
          parseFloat(this.state.amount) >= MINIMUM_WITHDRAW &&
          parseFloat(this.state.amount) <= parseFloat(this.state.balance)
          ? false
          : true;
    } else {
      returnval =
        !!this.state.accountHolderName &&
          this.state.accountHolderName.length > 1 &&
          !!this.state.accountNumber &&
          this.state.accountNumber.length > 4 &&
          !!this.state.amount &&
          parseFloat(this.state.amount) >= MINIMUM_WITHDRAW &&
          parseFloat(this.state.amount) <= parseFloat(this.state.balance)
          ? false
          : true;
    }
    return returnval;
  }
  onWithdrawalClick() {
    if(!(!!this.state.accountHolderName && this.state.accountHolderName.length > 1)){
      this.props.notify("Provide Account Holder Name", "error");
      return false;
    }
    if(!(!!this.state.accountNumber && this.state.accountNumber.length > 4)){
      this.props.notify("Provide Valid Account Number", "error");
      return false;
    }
    if(this.state.currentWithdrawalType === "bank" && !(!!this.state.iFSCCode && this.state.iFSCCode.length > 4)){
      this.props.notify("Provide Valid IFSC Code", "error");
      return false;
    }
    if(!(!!this.state.amount && parseFloat(this.state.amount) >= MINIMUM_WITHDRAW && parseFloat(this.state.amount) <= parseFloat(this.state.balance))){
      this.props.notify("Enter Valid Amount", "error");
      return false;
    }

    if(WithdrawInfoPopup){
      this.openWithdrawInfoPopup();
    } else {
      this.onWithdrawalClickAPI()
    }
  }

  openWithdrawInfoPopup(){
    this.props.MySwal.fire({
      title: "<strong>Withdrawal Info</strong>",
      icon: "",
      html: `
      <div class="">
        <div>
          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">Thanks for withdrawal Request</span> 
            </span>
          </h3>
          <p class="mb-0 text-black">आपने जो withdrawal request डालì है, वह आपके बैंक खाते में 2 मिनट से 120 मिनट के अंदर आ जाएगा। minimum 2 min maximum 120 min.</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="mb-0 text-black">The withdrawal request you have placed will be credited to your bank account within 2 minutes to 120 minutes. Minimum 2 min maximum 120 min.</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="text-black">మీరు చేసిన ఉపసంహరణ అభ్యర్థన 2 నిమిషాల నుండి 120 నిమిషాలలోపు మీ బ్యాంక్ ఖాతాకు క్రెడిట్ చేయబడుతుంది.  కనిష్టంగా 2 నిమిషాలు గరిష్టంగా 120 నిమిషాలు.</p>
        </div>
      </div>
      `,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Agree'
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.onWithdrawalClickAPI();
      }
    });
  }

  onWithdrawalClickAPI(){
    const self = this;
    let body = {
      operatorId: this.state.operatorId,
      username: this.state.userId,
      amount: this.state.amount,
      paymentMode: this.state.currentWithdrawalType,
      accountName: this.state.accountHolderName,
      accountNumber: this.state.accountNumber,
      routingInformation:
        this.state.currentWithdrawalType === "bank"
          ? this.state.iFSCCode
          : '',
    };
    // "email" : this.state.emailId,
    // "mobile" : this.state.mobileNumber,
    document.getElementById("btnWithdraw").disabled = true;
    depositWithdrawalService
      .withdrawalOrder(body)
      .then((res) => {
        document.getElementById("btnWithdraw").disabled = false;
        if (!!res) {
          if (!!res.withdrawId) {
            self.props.notify(
              `We have recevied your withdraw request. withdrawId: ${res.withdrawId}. For any support, contact our chat executive or whatsapp.`,
              "success"
            );
            self.props.hidePopup();
            self.setState(
              {
                // userId:'',
                // emailId:'',
                // mobileNumber:'',
                // operatorId: '',
                bankName: "",
                accountHolderName: "",
                accountNumber: "",
                iFSCCode: "",
                // balance: parseFloat(self.state.balance) - self.state.amount,
                amount: 0,
                // upiType: "Gpay",
                // walletName: "",
                // walletNumber: "",
              },
              () => {
                self.getBalance();

                // window.location.reload()
              }
            );
          } else {
            self.props.notify(
              `${res.exception.code} ${res.exception.message}`,
              "error"
            );
          }
        }
      })
      .catch((error) => {
        document.getElementById("btnWithdraw").disabled = false;
        self.props.notify(error, "error");
      });
  }

  onUsePreviousBankClick(itmm){
    this.setState({accountHolderName: itmm.accountHolderName, accountNumber: itmm.accountNumber, iFSCCode: itmm.ifscCode},()=>{
      this.getIFSCCodeDetailsFromCode(itmm.ifscCode)
    })
  }
  deletePreviousBank(itmm){
    const self = this;
    let profData = JSON.parse(localStorage.getItem('profData'));
    let body = {
      "operatorId": profData.operatorId,
      "username": profData.username,
      "accountNumber": itmm.accountNumber
    }
    this.setState({previousBankDetailsBtnLdr: true},()=>{
      xoroService.deleteMyPreviousBank(body).then((res) => {
        if (!!res && res.isSuccess) {
          self.props.notify('Account deleted successfully', "success");
          let prvacc = this.state.previousBankDetails.filter((ittm)=>ittm.accountNumber !== itmm.accountNumber);
  
          self.setState(
            { previousBankDetails: prvacc, previousBankDetailsBtnLdr: false }
          );
        } else {
          self.setState(
            { previousBankDetailsBtnLdr: false }
          );
          self.props.notify(res.exception.message, "error");
        }
      });
    })
  }

  copyToClipboard(content) {
    navigator.clipboard.writeText(content);
  }

  async onCryptoTrnnoPaste(event) {
    event.preventDefault();
    let pastedText = await navigator.clipboard.readText();
    var pastedTextRegex = /^[a-zA-Z0-9@]+$/;
    if (pastedTextRegex.test(pastedText)) {
      this.setState({
        utr: pastedText
      });
    } else {
      this.props.notify('Only AlphaNumeric is allowed here.', 'error');
    }
  }

  mqrSubmitFirstPayment() {
    const self = this;

    let cp = this.state.curPaymentType;
    if (
      this.state.xoroAmount === null ||
      this.state.xoroAmount === 0 ||
      this.state.xoroAmount === ""
    ) {
      this.showToast("Please enter amount", "error");
      return false;
    } else if (this.state.xoroAmount < 100) {
      this.showToast("Please enter min amount of 100.", "error");
      return false;
    }

    let frmData = {
      "email": this.state.emailId,
      "mobile": this.state.mobileNumber,
      "amount": this.state.xoroAmount,
      "account_operator_id": this.state.curAccount.operator_id,
      "account_name": this.state.curAccount.name,
      "account_id": this.state.curAccount.upi_id,
      "applied_bonus": this.state.bonusOfferApplied,
      "bonus_percentage": this.state.bonusOfferApplied && !!this.state.availableBonusOffers ? this.state.availableBonusOffers : 0
    }

    this.setState({ buttonLoader: true }, () => {
      xoroService.postMQRManualPayment(frmData).then((res) => {
        if (!!res && res.isSuccess) {
          const receiptNumber = res.data.receiptNumber;
          let appsbtn = {
            'gpay': `tez://upi/pay?pa=${this.state.curAccount.upi_id}&tr=${receiptNumber}&tn=${receiptNumber}&cu=INR&am=${this.state.xoroAmount}&pn=${this.state.curAccount.name}&mode=00&orgid=000000`,
            'phonepe': `phonepe://pay?pa=${this.state.curAccount.upi_id}&tr=${receiptNumber}&tn=${receiptNumber}&cu=INR&am=${this.state.xoroAmount}&pn=${this.state.curAccount.name}&mode=00&orgid=000000`,
            'paytm': `paytm://pay?pa=${this.state.curAccount.upi_id}&tr=${receiptNumber}&tn=${receiptNumber}&cu=INR&am=${this.state.xoroAmount}&pn=${this.state.curAccount.name}&mode=00&orgid=000000`,
            'upi': res.data.qrAddress
          }
          let secs = DEPOSIT_MQR_TIMER_SEC;
          let mqrtimerdisply = '';
          if (secs > 0) {
            let mins = DEPOSIT_MQR_TIMER_SEC / 60;
            if (mins > 0) {
              mqrtimerdisply = mqrtimerdisply + mins + 'm ';
            }
            mqrtimerdisply = mqrtimerdisply + secs + 's left';
          }

          // self.setState({ mqrImgDt: res.data.qrCode, buttonLoader: false, upiDirectButtonLink: appsbtn, receiptID: receiptNumber, mqrtimerseconds: secs, mqrtimerdisplay: mqrtimerdisply }, () => {
          self.setState({ mqrImgDt: res.data.qrAddress, buttonLoader: false, upiDirectButtonLink: appsbtn, receiptID: receiptNumber, mqrtimerseconds: secs, mqrtimerdisplay: mqrtimerdisply }, () => {
            self.mqrQRTimerStart();
          });
          // self.props.MySwal.fire({
          //   title: 'Success.',
          //   text: res.data.message,
          //   icon: 'success',
          //   confirmButtonText: 'OK',
          // }).then((result) => {
          //   if (result.isConfirmed) {
          //     self.props.hidePopup();
          //   }
          // })


          // self.setState(
          //   { xoroAmount: '', ss: {}, utr: "", buttonLoader: false },
          //   () => {
          //     if (!!document.getElementById("exampleFormControlFile1")) {
          //       document.getElementById("exampleFormControlFile1").value = "";
          //     }
          //   }
          // );
        } else {
          self.setState({ buttonLoader: false });
          self.props.notify(res.exception.message, "error");
        }
      });
    });
  }

  mqrSubmitSecondPayment() {
    // this.props.hidePopup();
    this.props.MySwal.fire({
      title: 'Success.',
      text: 'Payment Request Received',
      icon: 'success',
      confirmButtonText: 'OK',
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.hidePopup();
      }
    })
  }

  goOutOfMQR() {
    let paymentTypes = Object.keys(this.state.xoroData['payment_mode']).filter(
      (pm, i) => {
        return this.state.xoroData['payment_mode'][pm].length > 0;
      }
    );
    this.setState({ curPaymentType: paymentTypes[0] }, () => {
      this.setState({
        curAccount: this.state.xoroData['payment_mode'][paymentTypes[0]][0],
      });
    });
  }

  mqrQRTimerStart() {
    const self = this;
    mqrQRTimer = setInterval(async function timerUpdator() {
      clearInterval(mqrQRTimer);
      let secs = self.state.mqrtimerseconds - 1;
      let mqrtimerdisply = '';

      let mins = parseInt(secs / 60);
      if (mins > 0) {
        mqrtimerdisply = mqrtimerdisply + mins + 'm ';
      }
      mqrtimerdisply = mqrtimerdisply + (secs % 60) + 's left';


      self.setState({ mqrtimerseconds: secs, mqrtimerdisplay: mqrtimerdisply }, () => {
        if (self.state.mqrtimerseconds > 0) {
          mqrQRTimer = setInterval(timerUpdator, 1000);
        } else {
          self.props.hidePopup();
        }
      })
    }, 1000);
  }

  onIFSCBlur(){
    if(!!this.state.iFSCCode && this.state.iFSCCode.length === 11){
      this.getIFSCCodeDetailsFromCode(this.state.iFSCCode);
    } else {
      this.setState({
        ifscBankDetails:null
      })
    }
  }

  onBonusDetailsViewMore(){

    //<br>No Wagering required
    // <h3>Min deposit:&nbsp;₹300&nbsp;<br>Maximum Winning:${this.state.availableBonusOffers}% of your deposit up to ₹5000</h3>
    //       <p>Conditions</p>
    //       <h3>Bonus amount: ${this.state.availableBonusOffers}% of Deposit up to ₹5000 on every deposit<br>Min deposit: ₹300<br>Expiry: No Expiry</h3>

    this.props.MySwal.fire({
      title: "<strong>Bonus Details</strong>",
      icon: "",
      html: `
      <div class="">
        <div>
          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">${this.state.availableBonusOffers}% BONUS ON EVERY DEPOSIT. (No limit)</span> 
            </span>
          </h3>
          <ul>
              <li>
                  <p class="mb-0 text-black">1.) ${this.state.availableBonusOffers}% Flat Bonus Unlimited for Sports & Casino</p>
              </li>
              <li>
                  <p class="mb-0 text-black">2.) 60% Profit or Loss Must be require against your Total Amount*</p>
              </li>
              <li>
                  <p class="mb-0 text-black">3.) Single Shot bets are not allow*</p>
              </li>
              <li>
                  <p class="mb-0 text-black">4.) If Client not fulfil the above condition then the bonus amount will be deducted at the withdrawal time*</p>
              </li>
              <li>
                  <p class="mb-0 text-black">5.) Cross bets and hedging are not allowed.</p>
              </li>
              <li>
                  <p class="text-black">6.) If found more than one ID is related to the same IP Address/Device or taken any bonus schemes benefits, in that case, all the related IDs will be block immediately without any discussion*</p>
              </li>
          </ul>

          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">T&C</span> 
            </span>
          </h3>
          <ul>
              <li>
                  <p class="mb-0 text-black">1.) If there is any pending rollover at the time of withdrawal, in that case, it will be carried forward to the next deposit.</p>
              </li>
              <li>
                  <p class="mb-0 text-black">2.) Cross-bets and hedging are not allowed.</p>
              </li>
              <li>
                  <p class="mb-0 text-black">3.) If found more than one ID is related to the same IP Address/Device, in that case, all the related IDs will be blocked immediately without any discussion.</p>
              </li>
              <li>
                  <p class="mb-0 text-black">4.) If found more than one ID is requesting withdrawals in the same Bank Account, in that case, all the IDs related to that particular Bank Account will be blocked immediately.</p>
              </li>
          </ul>

          <p class="text-light-grey">--------------------------------------------------------</p>

          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">प्रत्येक जमा राशि पर ${this.state.availableBonusOffers}% बोनस। (कोई सीमा नहीं)</span> 
            </span>
          </h3>
          <ul>
              <li>
                  <p class="mb-0 text-black">1.) खेल और कैसीनो के लिए ${this.state.availableBonusOffers}% फ्लैट बोनस अनलिमिटेड</p>
              </li>
              <li>
                  <p class="mb-0 text-black">2.) आपकी कुल राशि पर 60% लाभ या हानि आवश्यक होनी चाहिए*</p>
              </li>
              <li>
                  <p class="mb-0 text-black">3.) सिंगल शॉट दांव की अनुमति नहीं है*</p>
              </li>
              <li>
                  <p class="mb-0 text-black">4.) यदि ग्राहक उपरोक्त शर्त को पूरा नहीं करता है तो निकासी के समय बोनस राशि काट ली जाएगी*</p>
              </li>
              <li>
                  <p class="mb-0 text-black">5.) क्रॉस बेट्स और हेजिंग की अनुमति नहीं है।</p>
              </li>
              <li>
                  <p class="text-black">6.) यदि एक से अधिक आईडी एक ही आईपी पते/डिवाइस से संबंधित पाई जाती हैं या किसी बोनस योजना का लाभ लिया गया है, तो उस स्थिति में, सभी संबंधित आईडी बिना किसी चर्चा के तुरंत ब्लॉक कर दी जाएंगी*</p>
              </li>
          </ul>

          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">नियम एवं शर्तें</span> 
            </span>
          </h3>
          <ul>
              <li>
                  <p class="mb-0 text-black">1.) यदि निकासी के समय कोई रोलओवर लंबित है, तो उस स्थिति में, इसे अगली जमा राशि में आगे बढ़ाया जाएगा।</p>
              </li>
              <li>
                  <p class="mb-0 text-black">2.) क्रॉस-बेट और हेजिंग की अनुमति नहीं है।</p>
              </li>
              <li>
                  <p class="mb-0 text-black">3.) यदि एक से अधिक आईडी एक ही आईपी एड्रेस/डिवाइस से संबंधित पाई जाती हैं, तो उस स्थिति में, सभी संबंधित आईडी को बिना किसी चर्चा के तुरंत ब्लॉक कर दिया जाएगा।</p>
              </li>
              <li>
                  <p class="mb-0 text-black">4.) यदि एक ही बैंक खाते में एक से अधिक आईडी से निकासी का अनुरोध पाया जाता है, तो उस स्थिति में, उस विशेष बैंक खाते से संबंधित सभी आईडी तुरंत ब्लॉक कर दी जाएंगी।</p>
              </li>
          </ul>
        </div>
      </div>
      `,
      showCloseButton: true,
    })
    // showCancelButton: true,
    // focusConfirm: false,
    // confirmButtonText: `
    //   <i class="fa fa-thumbs-up"></i> Great!
    // `,
    // confirmButtonAriaLabel: "Thumbs up, great!",
    // cancelButtonText: `
    //   <i class="fa fa-thumbs-down"></i>
    // `,
    // cancelButtonAriaLabel: "Thumbs down"
  }

  onBonusOfferClick(){
    if(this.state.bonusOfferApplied){
      this.setState({bonusOfferApplied: false});
    } else {
      if(DepositBonusOffersInfoPopup){
        this.props.MySwal.fire({
          title: "<strong>Bonus Rules</strong>",
          icon: "",
          html: `
          <div class="">
            <div>
              <p class="mb-0 text-black">Minimum 50% Profit loss compulsory & minimum 5 bet different market compulsory.</p>
              <p class="mb-0 text-black">Both condition is mandatory</p>
              <p class="text-black">Note-  No Bonus No rule</p>
            </div>
          </div>
          `,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'Agree'
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.setState({bonusOfferApplied: true});
          }
        });
      } else {
        this.setState({bonusOfferApplied: true});
      }
    }
  }

  render() {
    let xoroData = this.state.xoroData;
    const onlyAlphaNumeric = /[0-9a-zA-Z]+/g;
    const pymnttypeimg = {
      "bank": 'bank.png',
      "phonepe": 'phonepe.png',
      "googlepay": 'gpay.png',
      "paytm": 'paytm.png',
      "upi": 'upi.png',
      "nagad": 'nagad-icon.png',
      "bkash": 'bkash-icon.png',
      "rocket": 'rocket-icon.png',
      "upay": 'upay-icon.png'
    };
    console.log('this.state.curPaymentType',this.state.curPaymentType)
    return (
      <>
        <div id="marketbetspopup" className="modal fade show sign-up-form depositpopup" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
          {!!this.state.showToast && (<Toast notification={this.state.toastMsg} type={this.state.toastType} />)}
          <div className={`modal-dialog modal-sm ${((xoroData.gatewayVendor == "XOROPE" && this.state.xoropeDataLoaded && this.state.curPaymentType !== "mqr" && this.state.curPaymentType !== "whatsapp") && this.state.depositSelected === 1) || (this.state.depositSelected === -1) ? "manualdepositpopup" : ""}`}>
            {this.state.loading ? (<div className={"modal-content manualdeposit-loding"}>
              <h4 style={{ color: "black" }}>Loading...</h4>
            </div>
            )
            :
            <>
              {/* <div className={this.state.loading ? "modal-content d-none" : "modal-content"}> */}
              <div className="modal-content">
                <div className="modal-header ">
                  {/* <img style={{ width: "100%", borderRadius:"10px", marginBottom:"20px" }} src={BASE_IMAGE_PATH + "/casino/banner/images/depositbanner.webp"} alt={""}></img> */}
                  <button onClick={() => { this.props.hidePopup(); }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                {/* AMOUNT ADD WALLET DEPOSIT POPUP */}
                <div className="modal-body" id="content">
                  <div className="mb-1">
                    {/* {(xoroData.gatewayVendor === "XOROPE" && this.state.curPaymentType === "whatsapp") ? */}
                    {(this.state.curPaymentType === "whatsapp") ?
                      <>
                        <h4 className="text-dark">Deposit/Withdrawal</h4>
                      </>
                    :
                      <>
                        <span className="payment-methods__form-head-title">
                          <img src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/xoropelogo.png`} alt=''></img>
                        </span>
                        <div className="payment-methods__balance">
                          <span className="payment-methods__balance-title">
                            {" "}
                            Main Balance
                          </span>
                          <span className="payment-methods__balance-value">
                            {this.state.balance}
                          </span>
                        </div>
                      </>
                    }
                    {!!xoroData && !!xoroData.gatewayVendor && !(xoroData.gatewayVendor === "XOROPE" && ((this.state.curPaymentType === "mqr" && !!this.state.mqrImgDt) || this.state.curPaymentType === "whatsapp")) && this.state.curPaymentType !== "whatsapp" &&
                      <div className="d-flex justify-content-end">
                        <span className="small text-danger">
                          <i className="fa fa-info-circle mr-1"></i>
                          Amount should be atleast {this.state.depositSelected === 1 ? MINIMUM_DEPOSIT : (this.state.depositSelected === -1 ? MINIMUM_WITHDRAW : 100)}.
                        </span>
                      </div>
                    }
                  </div>
                  {!!xoroData && !!xoroData.gatewayVendor && (!(xoroData.gatewayVendor === "XOROPE" && ((this.state.curPaymentType === "mqr" && !!this.state.mqrImgDt) || this.state.curPaymentType === "whatsapp"))) && this.state.curPaymentType !== "whatsapp" &&

                    <div className="btn-group w-100 deposit-withdrowal-btn-box" role="group" aria-label="Basic example">
                      <button type="button" className={this.state.depositSelected === 1 ? "btn active w-50 depositbtn-new" : "btn btn-deposit w-50 depositbtn-new"} onClick={() => { this.setState({ depositSelected: 1 }); }}>
                        Click here for Deposit
                      </button>
                      <button type="button" className={this.state.depositSelected === -1 ? "btn btn-deposit active w-50" : "btn btn-deposit active w-50"} onClick={() => { this.setState({ depositSelected: -1 }); }}>
                        Click here for Withdrawal
                      </button>
                      {/* {OPERATOR_ID === "RDR" && (
                        <button
                          type="button"
                          className={
                            this.state.depositSelected === 0
                              ? "btn btn-deposit active w-50"
                              : "btn btn-deposit w-50"
                          }
                          onClick={() => {
                            this.setState({ depositSelected: 0 });
                          }}
                        >
                          Manual
                        </button>
                      )} */}
                    </div>
                  }
                  {/* <div className='deposit-withdrowal-btn-box'>dsdsd</div> */}
                  {/* <h5 className="modal-title mt-2 text-black text-center" id="myModalLabel">MAKE A DEPOSIT</h5>  */}
                  {/* NORMAL DEPOSIT POPUP START */}
                  {!!xoroData && !!xoroData.gatewayVendor && xoroData.gatewayVendor != "XOROPE" && this.state.curPaymentType !== "whatsapp" &&(
                    <div className="payment-methods">
                      {this.state.depositSelected === 1 && (
                        <div className="depositboxview">
                          {/* middle part start */}
                          <div className="payment-methods__detail-form payment-methods__scrollable">
                            <div className="payment-methods__form-head">
                              <div>
                                <div className="mt-0">
                                  {!!NonXoroPeDepositSupportNumber && !!NonXoroPeDepositSupportNumber.link && NonXoroPeDepositSupportNumber.link !== "" &&
                                    <div className="mb-3 pedepo_no">
                                      Facing difficulty in deposit ? Ask our agent for manually deposit Click here : <a href={NonXoroPeDepositSupportNumber.link}>{NonXoroPeDepositSupportNumber.displaynumber}</a>
                                    </div>
                                  }
                                  <div className="mb-3">
                                    <label
                                      htmlFor="depositAmount" className="uname mb-1" data-icon="u" > Amount (INR)</label>
                                    <input id="depositAmount" className="field" name="amount" required="required" type="number" onChange={(e) => this.onChange(e)} value={this.state.amount} onWheel={(e) => e.target.blur()} onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    />
                                    {!!this.state.amount &&
                                      this.state.amount < MINIMUM_DEPOSIT && (
                                        <label className="signup-validation-text" style={{ color: "red" }}>Minimum deposit amount is {MINIMUM_DEPOSIT}.</label>
                                      )}
                                  </div>
                                  {/* <div className='Deposit_amount-blocks-wrapper mb-3'>
                                                                  <button className="depositamount-btn" type="button" value="1000">1000</button>
                                                                  <button className="depositamount-btn" type="button" value="2000">2000</button>
                                                                  <button className="depositamount-btn" type="button" value="5000">5000</button>
                                                                  <button className="depositamount-btn" type="button" value="10000">10000</button>
                                                              </div> */}
                                  <div className="mb-3">
                                    <label
                                      htmlFor="userId"
                                      className="uname mb-1"
                                      data-icon="u"
                                    >
                                      User Id
                                    </label>
                                    <input id="userId" className="field" name="userId" required="required" type="text" value={this.state.userId} disabled />
                                  </div>

                                  <div className="mb-3">
                                    <label
                                      htmlFor="emailId"
                                      className="uname mb-1"
                                      data-icon="u"
                                    >
                                      Email Id
                                    </label>
                                    <input
                                      id="emailId"
                                      className="field"
                                      name="emailId"
                                      required="required"
                                      type="text"
                                      value={this.state.emailId}
                                      disabled
                                    />
                                  </div>
                                  <div className="mb-3">
                                    <label
                                      htmlFor="mobileNumber"
                                      className="uname mb-1"
                                      data-icon="u"
                                    >
                                      Mobile Number
                                    </label>
                                    <input
                                      id="mobileNumber"
                                      className="field"
                                      name="mobileNumber"
                                      required="required"
                                      type="text"
                                      value={this.state.mobileNumber}
                                      disabled
                                    />
                                  </div>
                                  {DepositBonusOffers && !!this.state.availableBonusOffers && this.state.availableBonusOffers !== 0 &&
                                    <>
                                    <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                      Available Offer:
                                    </label>
                                      <div className="d-flex justify-content-between mb-3">
                                        <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                          <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                        </label>

                                        <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                      </div>
                                    </>
                                  }
                                  <div className="checkout button mx-auto">
                                    <button
                                      className="btn-type-submit"
                                      onClick={() => this.onDepositClick()}
                                    >
                                      Deposit
                                    </button>
                                  </div>
                                  <div className="mt-2">
                                    <img
                                      className="w-25 d-inline-block"
                                      src={
                                        BASE_IMAGE_PATH +
                                        "/casino/banner/loginimages/ssl.png"
                                      }
                                      alt=""
                                    ></img>
                                    <div className="protected-connection ">
                                      <strong>100% SAFE</strong>
                                      <div>
                                        Protected connection and encrypted data.
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mt-2">
                                    <img
                                      className="w-50"
                                      src={
                                        BASE_IMAGE_PATH +
                                        "/casino/banner/loginimages/p1.png"
                                      }
                                      alt=""
                                    ></img>
                                    <img
                                      className="w-50"
                                      src={
                                        BASE_IMAGE_PATH +
                                        "/casino/banner/loginimages/p2.png"
                                      }
                                      alt=""
                                    ></img>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* END middle part */}
                        </div>
                      )}
                      {this.state.depositSelected === 0 && (
                        <div className="depositboxview">
                          <div className="payment-methods__detail-form payment-methods__scrollable">
                            <div className="payment-methods__form-head">
                              <div className="form-group">
                                <div className="manual-icon d-flex mb-3">
                                  <img
                                    src={
                                      BASE_IMAGE_PATH +
                                      "/casino/banner/loginimages/deposit-icon.png"
                                    }
                                    alt="Deposit"
                                    title="Deposit"
                                  ></img>
                                  <div className="form-title d-inline ml-2">
                                    For Deposit <br></br>
                                    {PAYINOUTMANUALNUMBERDEPOSIT.map((itm) => {
                                      return (
                                        <a
                                          className="link-over-white "
                                          href={`https://api.WhatsApp.com/send?phone=${itm.number}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <i className="fa fa-whatsapp mr-1"></i>
                                          {itm.label}
                                        </a>
                                      );
                                    })}
                                  </div>
                                </div>

                                <div className="manual-icon d-flex mb-3">
                                  <img
                                    src={
                                      BASE_IMAGE_PATH +
                                      "/casino/banner/loginimages/withdrawal-icon.png"
                                    }
                                    alt="Withdrawal"
                                    title="Withdrawal"
                                  ></img>
                                  <div className="form-title d-inline ml-2">
                                    For WIthdrawal <br></br>
                                    {PAYINOUTMANUALNUMBERWITHDRAWAL.map((itm) => {
                                      return (
                                        <a
                                          className="link-over-white "
                                          href={`https://api.WhatsApp.com/send?phone=${itm.number}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <i className="fa fa-whatsapp mr-1"></i>
                                          {itm.label}
                                        </a>
                                      );
                                    })}
                                  </div>
                                </div>

                                <div className="manual-icon d-flex mb-1">
                                  <img
                                    src={
                                      BASE_IMAGE_PATH +
                                      "/casino/banner/loginimages/support-icon.png"
                                    }
                                    alt="Support"
                                    title="Support"
                                  ></img>
                                  <div className="form-title d-inline ml-2">
                                    For Support <br></br>
                                    {PAYINOUTMANUALNUMBERSUPPORT.map((itm) => {
                                      return (
                                        <a
                                          className="link-over-white "
                                          href={`https://api.WhatsApp.com/send?phone=${itm.number}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <i className="fa fa-whatsapp mr-1"></i>
                                          {itm.label}
                                        </a>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* {this.state.depositSelected === -1 && (
                        <div className="depositboxview">
                          <div className="payment-methods__detail-form payment-methods__scrollable">
                            <div className="payment-methods__form-head">
                              {this.state.paymentMode === "Bank" && (
                                <>
                                  <div className="form-group">
                                    <label className="form--title">
                                      Account Holder Name
                                    </label>
                                    <input
                                      id="accountHolderName"
                                      className="form-control text-capitalize"
                                      name="accountHolderName"
                                      type="text"
                                      value={this.state.accountHolderName}
                                      onChange={(e) => this.onChange(e)}
                                    ></input>
                                  </div>
                                  <div className="form-group">
                                    <label className="form--title">
                                      Account Number
                                    </label>
                                    <input
                                      id="accountNumber"
                                      className="form-control"
                                      name="accountNumber"
                                      type="number"
                                      value={this.state.accountNumber}
                                      onChange={(e) => this.onChange(e)}
                                    ></input>
                                  </div>
                                  <div className="form-group">
                                    <label className="form--title">
                                      IFSC Code
                                    </label>
                                    <input
                                      id="iFSCCode"
                                      className="form-control text-uppercase"
                                      name="iFSCCode"
                                      type="text"
                                      value={this.state.iFSCCode}
                                      onChange={(e) => this.onChange(e)}
                                    ></input>
                                  </div>
                                </>
                              )}
                              {this.state.paymentMode === "UPI" && (
                                <>
                                  <div className="form-group">
                                    <label className="form--title">
                                      Select UPI
                                    </label>
                                    <select
                                      className="form-control"
                                      name="upiType"
                                      onChange={(e) => this.onChange(e)}
                                      value={this.state.upiType}
                                    >
                                      <option value="Gpay">Gpay</option>
                                      <option value="Phonepe">Phonepe</option>
                                      <option value="Paytm">Paytm</option>
                                      <option value="Bhim">Bhim</option>
                                      <option value="Bharatpe">Bharatpe</option>
                                    </select>
                                  </div>
                                  <div className="form-group">
                                    <label className="form--title">
                                      Wallet Name
                                    </label>
                                    <input
                                      id="walletName"
                                      className="form-control text-capitalize"
                                      name="walletName"
                                      type="text"
                                      value={this.state.walletName}
                                      onChange={(e) => this.onChange(e)}
                                    ></input>
                                  </div>
                                  <div className="form-group">
                                    <label className="form--title">
                                      Wallet Number
                                    </label>
                                    <input
                                      id="walletNumber"
                                      className="form-control"
                                      name="walletNumber"
                                      type="number"
                                      maxLength={15}
                                      value={this.state.walletNumber}
                                      onChange={(e) => this.onChange(e)}
                                    ></input>
                                  </div>
                                </>
                              )}
                              <div className="form-group">
                                <label className="form--title">Amount</label>
                                <input
                                  id="amount"
                                  className="form-control"
                                  name="amount"
                                  type="number"
                                  value={this.state.amount}
                                  onChange={(e) => this.onChange(e)}
                                  onWheel={(e) => e.target.blur()}
                                ></input>
                                {!!this.state.amount &&
                                  this.state.amount < MINIMUM_WITHDRAW ? (
                                  <label
                                    className="signup-validation-text"
                                    style={{ color: "red" }}
                                  >
                                    Minimum withdrawal amount is {MINIMUM_WITHDRAW}.
                                  </label>
                                ) : (
                                  !!this.state.amount &&
                                  (parseFloat(this.state.amount) >
                                    parseFloat(this.state.balance) ? (
                                    <label
                                      className="signup-validation-text"
                                      style={{ color: "red" }}
                                    >
                                      Withdrawal amount cannot be greater the
                                      balance.
                                    </label>
                                  ) : null)
                                )}
                              </div>
                              <div className="form-group">
                                <button
                                  id="btnWithdraw"
                                  className="btn-type-submit"
                                  disabled={this.validateWithdrawalForm()}
                                  onClick={() => this.onWithdrawalClick()}
                                >
                                  Withdraw
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  )}
                  {/* END NORMAL DEPOSIT POPUP  */}
                  {/* MANUAL DEPOSIT POPUP START */}
                  {((xoroData.gatewayVendor == "XOROPE" && Object.keys(xoroData.payment_mode).length > 0) || this.state.curPaymentType === "whatsapp") && (
                    <>
                      {this.state.depositSelected === 1 && (
                        <>
                          {this.state.curPaymentType === "whatsapp" ?
                          <>
                              <div className="payment-methods">
                                <div className="depositboxview">
                                  {/* middle part start */}
                                  <div className="payment-methods__detail-form payment-methods__padding payment-methods__scrollable">
                                    <div className="payment-methods__form-head">
                                      <div className="whatsapp-paymentbox">
                                        <div className="mt-0">
                                          <div className="payment-methods__scroll">
                                            <p>
                                              Easier & Faster Payment Transactions via WhatsApp. Get instant response! 
                                            </p>
                                            <p>&nbsp;</p>
                                            <p>
                                              Currently we accept DEPOSIT requests via WhatsApp. <b>24x7</b> Support Available!
                                            </p> 
                                            <button className="btn btn-block btn-success" onClick={()=>{window.open(`https://wa.me/+${this.state.curAccount.mobile_number}`, "_blank")}}>
                                              <i className="fa fa-whatsapp mr-2"></i>
                                              Click here to proceed
                                            </button>     
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* END middle part */}
                                </div>
                              </div>
                          </>
                            :
                            (
                              xoroData.gatewayVendor == "XOROPE" && this.state.curPaymentType === "mqr" ?
                            <>
                              <div className="payment-methods">
                                <div className="depositboxview">
                                  {/* middle part start */}
                                  <div className="payment-methods__detail-form payment-methods__padding payment-methods__scrollable">
                                    <div className="payment-methods__form-head">
                                      <div>
                                        <div className="mt-0">
                                          {!!this.state.mqrImgDt ?
                                            <>
                                              <div className="payment-methods__scroll">
                                                <div className="pb-2" id="screenshotElement">


                                                  {this.state.mqrtimerseconds > 0 && <div className="qrcode-timer">{this.state.mqrtimerdisplay}</div>}
                                                  <div className="d-flex">
                                                    <div className="w-60qr">
                                                    <div className="mb-2">
                                                    <div className="payment-methods__form-head-title UPI-title">
                                                      Transfer Amount
                                                    </div>
                                                    <div className="payment-methods__form-head-title UPI-amount">
                                                      Rs. {this.state.xoroAmount}.00/-
                                                    </div>
                                                  </div>
                                                  <div className="mb-2">
                                                    <div className="payment-methods__form-head-title UPI-title">
                                                      {/* Scan the QR code to pay, or Choose an app below */}
                                                      Scan the QR code to pay.
                                                    </div>
                                                    <div className="manual-deposit-QR">
                                                      {/* <img
                                                        style={{ height: "220px" }}
                                                        src={`${this.state.mqrImgDt}`}
                                                        alt=""
                                                      /> */}
                                                      <QRCode 
                                                        value={this.state.mqrImgDt} 
                                                        style={{ height: "auto", maxWidth: "90%", width: "90%" }}
                                                        />
                                                      {" "}
                                                    </div>
                                                  </div>
                                                  <div className="mb-2">
                                                    <div className="payment-methods__form-head-title UPI-title">
                                                      <span className="receipt-color">Receipt:</span> {this.state.receiptID}
                                                    </div>

                                                  </div>
                                                    </div>
                                                    <div className="w-2qr">&nbsp;</div>
                                                    <div className="w-40qr">
                                                      <div className="mb-2">
                                                        <div><img alt="" src="https://images.staticcontent.io/casino/banner/loginimages/phonepe-mobile.png" class="w-40pimage" onClick={()=>window.open(this.state.upiDirectButtonLink['phonepe'], '_blank')}></img></div>
                                                        <div><img alt="" src="https://images.staticcontent.io/casino/banner/loginimages/paytm-mobile.png" class="w-40pimage" onClick={()=>window.open(this.state.upiDirectButtonLink['paytm'], '_blank')}></img></div>
                                                        <div><img alt="" src="https://images.staticcontent.io/casino/banner/loginimages/gpay-mobile.png" class="w-40pimage" onClick={()=>window.open(this.state.upiDirectButtonLink['gpay'], '_blank')}></img></div>
                                                        <div><img alt="" src="https://images.staticcontent.io/casino/banner/loginimages/upi-mobile.png" class="w-40pimage" onClick={()=>window.open(this.state.upiDirectButtonLink['upi'], '_blank')}></img></div>
                                                        {DEPOSIT_MQR_DEMO_BTN !== ''&& <div><a href={DEPOSIT_MQR_DEMO_BTN} target="_blank" rel="noreferrer"><img className="w-75pimage" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/payment6.jpg"} alt=""></img></a></div>}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  
                                                </div>
                                                {/* <div className="mb-2">
                                              <div className="payment-methods__form-head-title UPI-title font-color-b">
                                                  Click below to open app
                                                </div>
                                              </div> */}
                                                {/* <div className="mb-3 img-p-space">
                                                {!!this.state.upiDirectButtonLink && Object.keys(this.state.upiDirectButtonLink).length > 0 &&
                                                  Object.keys(this.state.upiDirectButtonLink).map((itm,indx)=>{
                                                    return(
                                                      <a href={this.state.upiDirectButtonLink[itm]}  className="img-p-wight">
                                                      <img src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/depositicon/upilinkicons/${itm}.png`} alt=""></img>
                                                      </a>
                                                    )
                                                  })
                                                }
                                              </div> */}
                                                <div className="qrcode-text">
                                                  <div>Note :- For new Transactions:</div>
                                                  <div>Enter money in one QR only once, Create a new QR when you added money, Don't put money in this QR again</div>
                                                  {/* <div>नए अनुवादों के लिए:</div> */}
                                                  <div>एक QR में एक ही बार पैसे डाले, जब वी पैसा डाले नया QR बनाये, ये QR में दुबारा पैसा ना डाले</div>
                                                </div>
                                                <div className="button mx-auto mb-2">
                                                  <button
                                                    className="btn btn-block btn-outline-info btn-res-12"
                                                    onClick={() => this.captureScreenshot()}
                                                  >
                                                    Take a Screenshot
                                                  </button>
                                                  <button
                                                    className="btn btn-block btn-outline-info ml-1 mt-0 btn-res-12"
                                                    onClick={() => { this.props.hidePopup(); this.props.history.push('/home') }}
                                                  >
                                                    Back to home
                                                  </button>
                                                  {/* <button
                                                  className="btn btn-block btn-outline-info ml-1 mt-0"
                                                  onClick={() => this.shareImage(this.state.mqrImgDt)}
                                                >
                                                  Share QR
                                                </button> */}
                                                </div>
                                                {/* mqrtimerseconds: secs, mqrtimerdisplay: mqrtimerdisply */}


                                                {/* <div className="checkout button mx-auto">
                                                <button
                                                  className="btn-type-submit"
                                                  onClick={() => this.mqrSubmitSecondPayment()}
                                                >
                                                  Done
                                                </button>
                                                <button
                                                  className="btn-type-submit cancel-btn-bgcolor-red"
                                                  onClick={() => this.props.hidePopup()}
                                                >
                                                  Cancel
                                                </button>
                                              </div> */}
                                              </div>
                                            </>
                                            :
                                            <>
                                              <div className="mb-3">
                                                <label
                                                  htmlFor="depositAmount" className="uname mb-1" data-icon="u" > Amount (INR)</label>
                                                <input id="depositAmount" className="field" name="xoroAmount" required="required" type="number" onChange={(e) => this.onChange(e)} value={this.state.xoroAmount} onWheel={(e) => e.target.blur()} onKeyPress={(event) => {
                                                  if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                />
                                                {!!this.state.xoroAmount &&
                                                  this.state.xoroAmount < this.state.curAccount.min_limit && (
                                                    <label className="signup-validation-text" style={{ color: "red" }}>Minimum deposit amount is {this.state.curAccount.min_limit}.</label>
                                                  )}
                                              </div>
                                              {/* <div className="mb-3">
                                                <label
                                                  htmlFor="userId"
                                                  className="uname mb-1"
                                                  data-icon="u"
                                                >
                                                  Account Name
                                                </label>
                                                <input id="userId" className="field" name="curAccountName" required="required" type="text" value={this.state.curAccount.name} disabled />
                                              </div>
                                              <div className="mb-3">
                                                <label
                                                  htmlFor="userId"
                                                  className="uname mb-1"
                                                  data-icon="u"
                                                >
                                                  Wallet
                                                </label>
                                                <input id="userId" className="field" name="curAccountName" required="required" type="text" value={this.state.curAccount.upi_id} disabled />
                                              </div> */}

                                              <div className="mb-3">
                                                <label
                                                  htmlFor="emailId"
                                                  className="uname mb-1"
                                                  data-icon="u"
                                                >
                                                  Email Id
                                                </label>
                                                <input
                                                  id="emailId"
                                                  className="field"
                                                  name="emailId"
                                                  required="required"
                                                  type="text"
                                                  value={this.state.emailId}
                                                  disabled
                                                />
                                              </div>
                                              <div className="mb-3">
                                                <label
                                                  htmlFor="mobileNumber"
                                                  className="uname mb-1"
                                                  data-icon="u"
                                                >
                                                  Mobile Number
                                                </label>
                                                <input
                                                  id="mobileNumber"
                                                  className="field"
                                                  name="mobileNumber"
                                                  required="required"
                                                  type="text"
                                                  value={this.state.mobileNumber}
                                                  disabled
                                                />
                                              </div>
                                              {DepositBonusOffers && !!this.state.availableBonusOffers &&
                                                <>
                                                <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                                  Available Offer:
                                                </label>
                                                  <div className="d-flex justify-content-between mb-3">
                                                    <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                      <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                    </label>

                                                    <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                  </div>
                                                </>
                                              }
                                              <div className="mb-3">
                                                <p className="font-color-b font-bold font-16">If amount greater than 100,000
                                                  <button className="btn btn-link p-0 pl-1" onClick={() => { this.goOutOfMQR() }}>click here</button>
                                                </p>

                                              </div>
                                              <div className="checkout button mx-auto">
                                                <button
                                                  className="btn-type-submit"
                                                  onClick={() => this.mqrSubmitFirstPayment()}
                                                >
                                                  Submit
                                                </button>
                                              </div>
                                            </>
                                          }
                                          {/* <div className="mt-2">
                                              <img
                                                className="w-25 d-inline-block"
                                                src={
                                                  BASE_IMAGE_PATH +
                                                  "/casino/banner/loginimages/ssl.png"
                                                }
                                                alt=""
                                              ></img>
                                              <div className="protected-connection ">
                                                <strong>100% SAFE</strong>
                                                <div>
                                                  Protected connection and encrypted data.
                                                </div>
                                              </div>
                                            </div>
                                            <div className="mt-2">
                                              <img
                                                className="w-50"
                                                src={
                                                  BASE_IMAGE_PATH +
                                                  "/casino/banner/loginimages/p1.png"
                                                }
                                                alt=""
                                              ></img>
                                              <img
                                                className="w-50"
                                                src={
                                                  BASE_IMAGE_PATH +
                                                  "/casino/banner/loginimages/p2.png"
                                                }
                                                alt=""
                                              ></img>
                                            </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* END middle part */}
                                </div>
                              </div>

                            </>
                            :
                            <>
                              {/* <div className="manual-note">
                            <span>
                              <a>Watch Video How to deposit?</a>
                            </span>
                          </div> */}
                              <div className="manualdepositbox ">
                                <div className="payment-modal__inner">
                                  <div className="payment-methods">
                                    <div className="payment-methods__list payment-methods__scrollable">
                                      <div className="mobile-manual">
                                        {xoroData.payment_mode.phonepe.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "phonepe",
                                                curAccount:
                                                  xoroData.payment_mode.phonepe[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "phonepe"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/phonepe.png"
                                              }
                                              alt="Phonepe Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                PhonePe
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.googlepay.length >
                                          0 && (
                                            <div
                                              onClick={() => {
                                                this.setState({
                                                  curPaymentType: "googlepay",
                                                  curAccount:
                                                    xoroData.payment_mode.googlepay[0],
                                                  xoroAmount: '',
                                                  ss: {},
                                                  utr: "",
                                                });
                                                document.querySelector(
                                                  "#exampleFormControlFile1"
                                                ).value = null;
                                              }}
                                              className={
                                                this.state.curPaymentType ===
                                                  "googlepay"
                                                  ? "payment-method active"
                                                  : "payment-method"
                                              }
                                            >
                                              <img
                                                src={
                                                  BASE_IMAGE_PATH +
                                                  "/casino/banner/loginimages/depositicon/gpay.png"
                                                }
                                                alt="Google Pay Logo"
                                                className="payment-method-logo"
                                              />
                                              <div className="payment-method__middle">
                                                <span className="payment-method-name">
                                                  GooglePay
                                                </span>
                                              </div>
                                            </div>
                                          )}
                                        {xoroData.payment_mode.paytm.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "paytm",
                                                curAccount:
                                                  xoroData.payment_mode.paytm[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "paytm"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/paytm.png"
                                              }
                                              alt="Paytm Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Paytm
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.upi.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "upi",
                                                curAccount:
                                                  xoroData.payment_mode.upi[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "upi"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/upi.png"
                                              }
                                              alt="UPI Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                UPI
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.bkash.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "bkash",
                                                curAccount:
                                                  xoroData.payment_mode.bkash[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "bkash"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/bkash-icon.png"
                                              }
                                              alt="bkash Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Bkash
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.nagad.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "nagad",
                                                curAccount:
                                                  xoroData.payment_mode.nagad[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "nagad"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/nagad-icon.png"
                                              }
                                              alt="nagad Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Nagad
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.rocket.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "rocket",
                                                curAccount:
                                                  xoroData.payment_mode.rocket[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "rocket"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/rocket-icon.png"
                                              }
                                              alt="rocket Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Rocket
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.upay.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "upay",
                                                curAccount:
                                                  xoroData.payment_mode.upay[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "upay"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/upay-icon.png"
                                              }
                                              alt="upay Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Upay
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.bank_account.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "bank_account",
                                                curAccount:
                                                  xoroData.payment_mode
                                                    .bank_account[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType ===
                                                "bank_account"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/bank.png"
                                              }
                                              alt="Bank Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                BankAcc
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.crypto.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "crypto",
                                                curAccount:
                                                  xoroData.payment_mode.crypto[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "crypto"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/crypto.png"
                                              }
                                              alt="Crypto Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Crypto
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                        {xoroData.payment_mode.cash.length > 0 && (
                                          <div
                                            onClick={() => {
                                              this.setState({
                                                curPaymentType: "cash",
                                                curAccount:
                                                  xoroData.payment_mode.cash[0],
                                                xoroAmount: '',
                                                ss: {},
                                                utr: "",
                                              });
                                              document.querySelector(
                                                "#exampleFormControlFile1"
                                              ).value = null;
                                            }}
                                            className={
                                              this.state.curPaymentType === "cash"
                                                ? "payment-method active"
                                                : "payment-method"
                                            }
                                          >
                                            <img
                                              src={
                                                BASE_IMAGE_PATH +
                                                "/casino/banner/loginimages/depositicon/cash.png"
                                              }
                                              alt="Cash Logo"
                                              className="payment-method-logo"
                                            />
                                            <div className="payment-method__middle">
                                              <span className="payment-method-name">
                                                Cash
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="payment-methods__detail-form payment-methods__scrollable">

                                      {/* "nagad", "bkash", "rocket", "upay" DESIGN */}
                                      {(["nagad", "bkash", "rocket", "upay"].includes(this.state.curPaymentType)) && (
                                        <>
                                          <div className="container">
                                            <div className="row">
                                              <div className="col-12 col-sm-12 col-md-12">
                                                <div
                                                  className="btn-group mb-2 deposit-withdrowal-btn-box br5"
                                                  role="group"
                                                  aria-label="Basic example"
                                                >
                                                  {xoroData.payment_mode[
                                                    this.state.curPaymentType
                                                  ].map((acc) => {
                                                    return (
                                                      <button
                                                        type="button"
                                                        onClick={() => {
                                                          this.setState({
                                                            curAccount: acc,
                                                            xoroAmount: '',
                                                            ss: {},
                                                            utr: "",
                                                          });
                                                          document.querySelector(
                                                            "#exampleFormControlFile1"
                                                          ).value = null;
                                                        }}
                                                        className={
                                                          acc.name ===
                                                            this.state.curAccount.name
                                                            ? "btn btn-deposit active"
                                                            : "btn btn-deposit"
                                                        }
                                                      >
                                                        {acc.name}
                                                      </button>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row manual-container-qr">
                                              <>
                                                <div className={`col-12 ${this.state.curPaymentType !== "upi" ? 'col-sm-6 col-md-4' : 'col-sm-12 col-md-12'}`}>
                                                  <div className="">
                                                    {this.state.curPaymentType !== "upi" &&
                                                      <div className="payment-methods__form-head">
                                                        <span className="payment-methods__form-head-title UPI-title">
                                                          Scan the QR code to pay
                                                        </span>
                                                      </div>
                                                    }
                                                    {this.state.curPaymentType !== "upi" &&
                                                      <div className="manual-deposit-QR">
                                                        <img
                                                          src={`${this.state.curAccount.qr_code}?${new Date().getTime()}`}
                                                          alt=""
                                                        />{" "}
                                                      </div>
                                                    }
                                                    <div className="manual-min-max text-right w-100" >
                                                      <span className="mr-2">
                                                        Min:
                                                        {
                                                          this.state.curAccount
                                                            .min_limit
                                                        }
                                                      </span>
                                                      <span>
                                                        Max:
                                                        {
                                                          this.state.curAccount
                                                            .max_limit
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className={`col-12 col-sm-6 col-md-8`}>
                                                  <div className="row transfernote ">
                                                    {/* <p>👉 User is requested to fill mandatory fields, if not submitted properly within 1 hour of the transaction payment will be deemed as zero.False claims will has legal consiquences.</p> */}

                                                    <div className="payment-box-deposit">
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Account Name:</label>
                                                        <label className="payments-data__field" >{this.state.curAccount.name}</label>
                                                        {/* <input className="payments-data__field" id="payments-data-01" type="text"  value={this.state.curAccount.name}/> */}
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Wallet:</label>
                                                        <label className="payments-data__field" >{this.state.curAccount.upi_id} <i className="fa fa-clone" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.state.curAccount.upi_id)}></i></label>
                                                      </div>
                                                      <div className="payments-help">
                                                        <span className="payments-help__icon">
                                                          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                        </span>
                                                        <div className="payments-help__body">
                                                          <p className="payments-help__text">Once you make the payment to the above account, please enter required details below and confirm successful deposit.</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="payment-box-deposit payment-box-deposit-seccess">
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Amount:</label>
                                                        <input className="payments-data__field" placeholder="Enter Your Amount Here" id="payments-data-01" type="number" value={this.state.xoroAmount} onChange={(e) => { this.setState({ xoroAmount: e.target.value, }); }} onKeyPress={(event) => {
                                                          if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                          }
                                                        }} />
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Sender Mob Number:</label>
                                                        <input className="payments-data__field" placeholder="Enter Sender Mobile Number" id="payments-data-01" type="number" value={this.state.utr} onChange={(e) => { this.setState({ utr: e.target.value, }); }} />
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Upload Screenshot :</label>
                                                        <input type="file" className="payments-data__field" id="exampleFormControlFile1" accept="image/*" onChange={this.selectFile} />
                                                      </div>
                                                    </div>
                                                      {DepositBonusOffers && !!this.state.availableBonusOffers &&
                                                        <>
                                                          <div className="col-12 bonus-strip">
                                                            <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                                              Available Offer:
                                                            </label>
                                                            <div className="d-flex justify-content-between mb-3">
                                                              <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                                <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                              </label>

                                                              <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }
                                                    <div className="col-12 col-sm-12 col-md-12">
                                                      <div className="form-group pull-right mb-1">
                                                        <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.submitPayment(); }} >
                                                          {this.state.buttonLoader &&
                                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                              <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                            </svg>}
                                                          Submit
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                              {/* ); */}
                                              {/* })} */}
                                            </div>
                                            <div className="row mt-2 transfernote d-none">
                                              <p>
                                                👉 After transfer the amount, submit
                                                12 Digit UTR Number, click "Continue"
                                                button.
                                              </p>
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="form-group">
                                                  {/* <label htmlFor="email">UserName:</label> */}
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="UserName"
                                                    id="email"
                                                    disabled
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="form-group">
                                                  {/* <label htmlFor="email">Amount:</label> */}
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Amount"
                                                    id="amount"
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="form-group">
                                                  {/* <label htmlFor="email">UTR No:</label> */}
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter UTR No"
                                                    id="UTR"
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="form-group">
                                                  <select
                                                    title="Transaction Types"
                                                    className="form-control"
                                                    name="types"
                                                  >
                                                    <option value="ALL">
                                                      Select Account Id:
                                                    </option>
                                                    <option value="6546546546">
                                                      6546546546
                                                    </option>
                                                    <option value="654654654dfs">
                                                      654654654dfs
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="form-group">
                                                  <label htmlFor="file">
                                                    Upload Screenshot :
                                                  </label>
                                                  <input
                                                    type="file"
                                                    className="form-control-file"
                                                    id="exampleFormControlFile1"
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="form-group">
                                                  {/* <label htmlFor="file">Screenshot Upload:</label> */}
                                                  <button className="btn place-bet-btn mt-2">
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {/* PHONE Pe, Gpay, Paytm and UPI DESIGN */}
                                      {(this.state.curPaymentType === "phonepe" ||
                                        this.state.curPaymentType === "googlepay" ||
                                        this.state.curPaymentType === "paytm" ||
                                        this.state.curPaymentType === "upi") && (
                                          <>
                                            <div className="container">
                                              <div className="row">
                                                <div className="col-12 col-sm-12 col-md-12">
                                                  <div
                                                    className="btn-group mb-2 deposit-withdrowal-btn-box br5"
                                                    role="group"
                                                    aria-label="Basic example"
                                                  >
                                                    {xoroData.payment_mode[
                                                      this.state.curPaymentType
                                                    ].map((acc) => {
                                                      return (
                                                        <button
                                                          type="button"
                                                          onClick={() => {
                                                            this.setState({
                                                              curAccount: acc,
                                                              xoroAmount: '',
                                                              ss: {},
                                                              utr: "",
                                                            });
                                                            document.querySelector(
                                                              "#exampleFormControlFile1"
                                                            ).value = null;
                                                          }}
                                                          className={
                                                            acc.name ===
                                                              this.state.curAccount.name
                                                              ? "btn btn-deposit active"
                                                              : "btn btn-deposit"
                                                          }
                                                        >
                                                          {acc.name}
                                                        </button>
                                                      );
                                                    })}
                                                    {/* <button
                                                type="button"
                                                className="btn btn-deposit active"
                                              >
                                                PhonePe 1
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-deposit"
                                              >
                                                PhonePe 2
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-deposit"
                                              >
                                                PhonePe 3
                                              </button> */}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="row manual-container-qr">
                                                {/* {xoroData.payment_mode[
                                            this.state.curPaymentType
                                          ].map((po, i) => {
                                            return ( */}
                                                <>
                                                  <div className={`col-12 ${this.state.curPaymentType !== "upi" ? 'col-sm-6 col-md-4' : 'col-sm-12 col-md-12'}`}>
                                                    <div className="">
                                                      {this.state.curPaymentType !== "upi" &&
                                                        <div className="payment-methods__form-head">
                                                          <span className="payment-methods__form-head-title UPI-title">
                                                            {/* {this.state.curAccount.name}{" "} */}Scan the QR code to pay
                                                          </span>
                                                        </div>
                                                      }
                                                      {this.state.curPaymentType !== "upi" &&
                                                        <div className="manual-deposit-QR">
                                                          <img
                                                            src={`${this.state.curAccount.qr_code}?${new Date().getTime()}`}
                                                            alt=""
                                                          />{" "}
                                                        </div>
                                                      }
                                                      {/* <div className={this.state.curPaymentType !== "upi" ? "UPI-title" : "UPI-title font-weight-bold"}>
                                                  {this.state.curAccount.upi_id}
                                                </div> */}
                                                      <div className="manual-min-max text-right w-100" >
                                                        <span className="mr-2">
                                                          Min:
                                                          {
                                                            this.state.curAccount
                                                              .min_limit
                                                          }
                                                        </span>
                                                        <span>
                                                          Max:
                                                          {
                                                            this.state.curAccount
                                                              .max_limit
                                                          }
                                                        </span>
                                                      </div>
                                                      {/* <div className="divider"></div> */}
                                                    </div>
                                                  </div>
                                                  <div className={`col-12 ${this.state.curPaymentType !== "upi" ? 'col-sm-6 col-md-8' : 'col-sm-12 col-md-12'}`}>
                                                    <div className="row transfernote ">
                                                      {/* <p>👉 User is requested to fill mandatory fields, if not submitted properly within 1 hour of the transaction payment will be deemed as zero.False claims will has legal consiquences.</p> */}

                                                      <div className="payment-box-deposit">
                                                        <div className="payments-data__group">
                                                          <label className="payments-data__label" >Account Name:</label>
                                                          <label className="payments-data__field" >{this.state.curAccount.name}</label>
                                                          {/* <input className="payments-data__field" id="payments-data-01" type="text"  value={this.state.curAccount.name}/> */}
                                                        </div>
                                                        <div className="payments-data__group">
                                                          <label className="payments-data__label" >Wallet:</label>
                                                          <label className="payments-data__field" >{this.state.curAccount.upi_id} <i className="fa fa-clone" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.state.curAccount.upi_id)}></i></label>
                                                        </div>
                                                        <div className="payments-help">
                                                          <span className="payments-help__icon">
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                          </span>
                                                          <div className="payments-help__body">
                                                            <p className="payments-help__text">Once you make the payment to the above account, please enter required details below and confirm successful deposit.</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="payment-box-deposit payment-box-deposit-seccess">
                                                        <div className="payments-data__group">
                                                          <label className="payments-data__label" >Amount:</label>
                                                          <input className="payments-data__field" placeholder="Enter Your Amount Here" id="payments-data-01" type="number" value={this.state.xoroAmount} onChange={(e) => { this.setState({ xoroAmount: e.target.value, }); }} onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                              event.preventDefault();
                                                            }
                                                          }} />
                                                        </div>
                                                        <div className="payments-data__group">
                                                          <label className="payments-data__label" >UTR No:</label>
                                                          <input className="payments-data__field" placeholder="Enter Your UTR Here" id="payments-data-01" type="number" value={this.state.utr} onChange={(e) => { this.setState({ utr: e.target.value, }); }} />
                                                        </div>
                                                        <div className="payments-data__group">
                                                          <label className="payments-data__label" >Upload Screenshot :</label>
                                                          <input type="file" className="payments-data__field" id="exampleFormControlFile1" accept="image/*" onChange={this.selectFile} />
                                                        </div>
                                                      </div>
                                                      {DepositBonusOffers && !!this.state.availableBonusOffers &&
                                                        <>
                                                          <div className="col-12 bonus-strip">
                                                            <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                                              Available Offer:
                                                            </label>
                                                            <div className="d-flex justify-content-between mb-3">
                                                              <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                                <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                              </label>

                                                              <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }
                                                      <div className="col-12 col-sm-12 col-md-12">
                                                        <div className="form-group pull-right mb-1">
                                                          <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.submitPayment(); }} >
                                                            {this.state.buttonLoader &&
                                                              <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                              </svg>}
                                                            Submit
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                                {/* ); */}
                                                {/* })} */}
                                              </div>
                                              <div className="row mt-2 transfernote d-none">
                                                <p>
                                                  👉 After transfer the amount, submit
                                                  12 Digit UTR Number, click "Continue"
                                                  button.
                                                </p>
                                                <div className="col-12 col-sm-6 col-md-4">
                                                  <div className="form-group">
                                                    {/* <label htmlFor="email">UserName:</label> */}
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="UserName"
                                                      id="email"
                                                      disabled
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4">
                                                  <div className="form-group">
                                                    {/* <label htmlFor="email">Amount:</label> */}
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Amount"
                                                      id="amount"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4">
                                                  <div className="form-group">
                                                    {/* <label htmlFor="email">UTR No:</label> */}
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Enter UTR No"
                                                      id="UTR"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4">
                                                  <div className="form-group">
                                                    <select
                                                      title="Transaction Types"
                                                      className="form-control"
                                                      name="types"
                                                    >
                                                      <option value="ALL">
                                                        Select Account Id:
                                                      </option>
                                                      <option value="6546546546">
                                                        6546546546
                                                      </option>
                                                      <option value="654654654dfs">
                                                        654654654dfs
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4">
                                                  <div className="form-group">
                                                    <label htmlFor="file">
                                                      Upload Screenshot :
                                                    </label>
                                                    <input
                                                      type="file"
                                                      className="form-control-file"
                                                      id="exampleFormControlFile1"
                                                    />
                                                  </div>
                                                </div>
                                                <div className="col-12 col-sm-6 col-md-4">
                                                  <div className="form-group">
                                                    {/* <label htmlFor="file">Screenshot Upload:</label> */}
                                                    <button className="btn place-bet-btn mt-2">
                                                      Submit
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}

                                      {/* Bank DESIGN */}
                                      {this.state.curPaymentType ===
                                        "bank_account" && (
                                          <>
                                            <div className="container">
                                              <div className="row">
                                                <div className="col-12 col-sm-12 col-md-12">
                                                  <div
                                                    className="btn-group mb-2 deposit-withdrowal-btn-box br5"
                                                    role="group"
                                                    aria-label="Basic example"
                                                  >
                                                    {xoroData.payment_mode[
                                                      this.state.curPaymentType
                                                    ].map((acc) => {
                                                      return (
                                                        <button
                                                          type="button"
                                                          onClick={() => {
                                                            this.setState({
                                                              curAccount: acc,
                                                              xoroAmount: '',
                                                              ss: {},
                                                              utr: "",
                                                            });
                                                            document.querySelector(
                                                              "#exampleFormControlFile1"
                                                            ).value = null;
                                                          }}
                                                          className={
                                                            acc.account_number ===
                                                              this.state.curAccount
                                                                .account_number
                                                              ? "btn btn-deposit active"
                                                              : "btn btn-deposit"
                                                          }
                                                        >
                                                          {acc.bank_name}
                                                        </button>
                                                      );
                                                    })}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="row  manual-container-qr">
                                                {/* {xoroData.payment_mode[
                                            this.state.curPaymentType
                                          ].map((po, i) => {
                                            return ( */}

                                                <div className="col-12 col-sm-12 col-md-12">
                                                  <div className="row transfernote ">
                                                    {/* <p>👉 User is requested to fill mandatory fields, if not submitted properly within 1 hour of the transaction payment will be deemed as zero.False claims will has legal consiquences.</p> */}
                                                    <div className="manual-min-max text-right w-100">
                                                      <span className="mr-2"> Min: {this.state.curAccount.min_limit} </span>
                                                      <span> Max: {this.state.curAccount.max_limit}  </span>
                                                    </div>
                                                    <div className="payment-box-deposit">
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Bank Name:</label>
                                                        <label className="payments-data__field" >{this.state.curAccount.bank_name}</label>
                                                        {/* <input className="payments-data__field" id="payments-data-01" type="text"  value={this.state.curAccount.name}/> */}
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Account Holder Name:</label>
                                                        <label className="payments-data__field" >{this.state.curAccount.account_holder_name} <i className="fa fa-clone" title="click to copy" alt="click to copy" aria-hidden="true" onClick={() => this.copyToClipboard(this.state.curAccount.account_holder_name)}></i></label>
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Account Number:</label>
                                                        <label className="payments-data__field" >{this.state.curAccount.account_number} <i className="fa fa-clone" title="click to copy" alt="click to copy" aria-hidden="true" onClick={() => this.copyToClipboard(this.state.curAccount.account_number)}></i></label>
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >IFSC Code:</label>
                                                        <label className="payments-data__field" >{this.state.curAccount.ifsc_code} <i className="fa fa-clone" title="click to copy" alt="click to copy" aria-hidden="true" onClick={() => this.copyToClipboard(this.state.curAccount.ifsc_code)}></i></label>
                                                      </div>
                                                      <div className="payments-help">
                                                        <span className="payments-help__icon">
                                                          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                        </span>
                                                        <div className="payments-help__body">
                                                          <p className="payments-help__text">Once you make the payment to the above account, please enter required details below and confirm successful deposit.</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="payment-box-deposit payment-box-deposit-seccess">
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Amount:</label>
                                                        <input className="payments-data__field" placeholder="Amount" id="payments-data-01" type="number" value={this.state.xoroAmount} onChange={(e) => { this.setState({ xoroAmount: e.target.value, }); }} onKeyPress={(event) => {
                                                          if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                          }
                                                        }} />
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >UTR No:</label>
                                                        <input className="payments-data__field" placeholder="Enter Your UTR Here" id="payments-data-01" type="number" value={this.state.utr} onChange={(e) => { this.setState({ utr: e.target.value, }); }} />
                                                      </div>
                                                      <div className="payments-data__group">
                                                        <label className="payments-data__label" >Upload Screenshot :</label>
                                                        <input type="file" className="payments-data__field" id="exampleFormControlFile1" accept="image/*" onChange={this.selectFile} />
                                                      </div>
                                                    </div>
                                                      {DepositBonusOffers && !!this.state.availableBonusOffers &&
                                                        <>
                                                          <div className="col-12 bonus-strip">
                                                            <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                                              Available Offer:
                                                            </label>
                                                            <div className="d-flex justify-content-between mb-3">
                                                              <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                                <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                              </label>

                                                              <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }

                                                    <div className="col-12 col-sm-12 col-md-12">
                                                      <div className="form-group pull-right mb-1">
                                                        <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.submitPayment(); }} >
                                                          {this.state.buttonLoader &&
                                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                              <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                            </svg>}
                                                          Submit
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {/* ); */}
                                                {/* })} */}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      {/* CRYPTO DESIGN */}
                                      {this.state.curPaymentType === "crypto" && (
                                        <>
                                          <div className="container">
                                            <div className="row">
                                              <div className="col-12 col-sm-12 col-md-12">
                                                <div
                                                  className="btn-group mb-2 deposit-withdrowal-btn-box br5"
                                                  role="group"
                                                  aria-label="Basic example"
                                                >
                                                  {xoroData.payment_mode[
                                                    this.state.curPaymentType
                                                  ].map((acc) => {
                                                    return (
                                                      <button
                                                        type="button"
                                                        onClick={() => {
                                                          this.setState({
                                                            curAccount: acc,
                                                            xoroAmount: '',
                                                            ss: {},
                                                            utr: "",
                                                          });
                                                        }}
                                                        className={
                                                          acc.crypto_name ===
                                                            this.state.curAccount
                                                              .crypto_name
                                                            ? "btn btn-deposit active"
                                                            : "btn btn-deposit"
                                                        }
                                                      >
                                                        {acc.crypto_name}
                                                      </button>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row manual-container-qr">
                                              {/* {xoroData.payment_mode[
                                            this.state.curPaymentType
                                          ].map((po, i) => {
                                            return ( */}
                                              <div className="col-12 col-sm-6 col-md-4">
                                                <div className="">
                                                  <div className="payment-methods__form-head">
                                                    <span className="payment-methods__form-head-title UPI-title">
                                                      {/* {
                                                    this.state.curAccount
                                                      .crypto_name
                                                  } */}
                                                      Scan the QR code to pay
                                                    </span>
                                                  </div>
                                                  <div className="manual-deposit-QR">
                                                    <img src={`${this.state.curAccount.qr_code}?${new Date().getTime()}`} alt="QR Code" />
                                                  </div>
                                                  {/* <div className="UPI-title">
                                                Crypto Address:{" "}
                                                {
                                                  this.state.curAccount
                                                    .crypto_address
                                                }
                                              </div> */}
                                                  {/* <div className="manual-min-max">
                                                Conversion Rate:{" "}
                                                {
                                                  this.state.curAccount
                                                    .conversion_rate
                                                }
                                              </div> */}
                                                  <div className="manual-min-max">
                                                    <span className="mr-2">
                                                      Min:
                                                      {
                                                        this.state.curAccount
                                                          .min_limit
                                                      }
                                                    </span>
                                                    <span>
                                                      Max:
                                                      {
                                                        this.state.curAccount
                                                          .max_limit
                                                      }
                                                    </span>
                                                  </div>
                                                  {/* <div className="divider"></div> */}
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-8">
                                                <div className="row transfernote ">
                                                  {/* <p>👉 User is requested to fill mandatory fields, if not submitted properly within 1 hour of the transaction payment will be deemed as zero.False claims will has legal consiquences.</p> */}
                                                  <div className="payment-box-deposit">
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Wallet Type:</label>
                                                      <label className="payments-data__field" >{this.state.curAccount.crypto_name}</label>
                                                      {/* <input className="payments-data__field" id="payments-data-01" type="text"  value={this.state.curAccount.name}/> */}
                                                    </div>
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Wallet:</label>
                                                      <label className="payments-data__field" >{this.state.curAccount.crypto_address} <i className="fa fa-clone crypto" title="click to copy" alt="click to copy" aria-hidden="true" onClick={() => this.copyToClipboard(this.state.curAccount.crypto_address)}></i></label>
                                                    </div>
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Conversion Rate:</label>
                                                      <label className="payments-data__field" >{this.state.curAccount.conversion_rate} </label>
                                                    </div>
                                                    <div className="payments-help">
                                                      <span className="payments-help__icon">
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                      </span>
                                                      <div className="payments-help__body">
                                                        <p className="payments-help__text">Once you make the payment to the above account, please enter required details below and confirm successful deposit.</p>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  {/* <div className="col-12 col-sm-12 col-md-12">
                                                <div className="form-group">
                                                  <label htmlFor="email">
                                                  Crypto Address:
                                                  </label>
                                                <span className="UPI-title">
                                                      {
                                                        this.state.curAccount
                                                          .crypto_address
                                                      }
                                                </span> 
                                                </div>
                                              
                                              </div> */}

                                                  <div className="payment-box-deposit payment-box-deposit-seccess">
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Amount: <span>{!!this.state.xoroAmount && this.state.xoroAmount > 0 ? this.state.xoroAmount * this.state.curAccount.conversion_rate : 0}/-</span></label>
                                                      <input className="payments-data__field" placeholder="Enter Your Amount Here" id="payments-data-01" type="number" value={this.state.xoroAmount} onChange={(e) => { this.setState({ xoroAmount: e.target.value, }); }} onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }} />
                                                    </div>
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Trns No:</label>
                                                      <input className="payments-data__field" placeholder="Enter Your Trns Here" id="payments-data-01" type="text" autoComplete="off" value={this.state.utr} onKeyPress={(e) => { if (!onlyAlphaNumeric.test(e.key)) { e.preventDefault() } }} onPaste={(e) => this.onCryptoTrnnoPaste(e)} onChange={(e) => { this.setState({ utr: e.target.value, }); }} />
                                                    </div>
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Upload Screenshot :</label>
                                                      <input type="file" className="payments-data__field" id="exampleFormControlFile1" accept="image/*" onChange={this.selectFile} />
                                                    </div>
                                                  </div>
                                                      {DepositBonusOffers && !!this.state.availableBonusOffers &&
                                                        <>
                                                          <div className="col-12 bonus-strip">
                                                            <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                                              Available Offer:
                                                            </label>
                                                            <div className="d-flex justify-content-between mb-3">
                                                              <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                                <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                              </label>

                                                              <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }
                                                  <div className="col-12 col-sm-12 col-md-12">
                                                    <div className="form-group pull-right mb-1">
                                                      <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.submitPayment(); }} >
                                                        {this.state.buttonLoader &&
                                                          <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                          </svg>}
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* );
                                          })} */}
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {/* CASH DESIGN */}
                                      {this.state.curPaymentType === "cash" && (
                                        <>
                                          <div className="container">
                                            <div className="row">
                                              <div className="col-12 col-sm-12 col-md-12">
                                                <div
                                                  className="btn-group mb-2 deposit-withdrowal-btn-box br5"
                                                  role="group"
                                                  aria-label="Basic example"
                                                >
                                                  {xoroData.payment_mode[
                                                    this.state.curPaymentType
                                                  ].map((acc) => {
                                                    return (
                                                      <button
                                                        type="button"
                                                        onClick={() => {
                                                          this.setState({
                                                            curAccount: acc,
                                                            xoroAmount: '',
                                                            ss: {},
                                                            utr: "",
                                                          });
                                                          document.querySelector(
                                                            "#exampleFormControlFile1"
                                                          ).value = null;
                                                        }}
                                                        className={
                                                          "btn btn-deposit active"
                                                        }
                                                      >
                                                        Cash
                                                      </button>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row manual-container-qr">

                                              <div className="col-12 col-sm-12 col-md-12">
                                                <div className="row transfernote ">
                                                  {xoroData.payment_mode[
                                                    this.state.curPaymentType
                                                  ].map((po, i) => {
                                                    return (
                                                      <>
                                                        <div className="manual-min-max text-right w-100">
                                                          <span className="mr-2"> Min: {po.min_limit} </span>
                                                          <span> Max: {po.max_limit}  </span>
                                                        </div>

                                                      </>
                                                    )
                                                  })}

                                                  {/* <p>👉 User is requested to fill mandatory fields, if not submitted properly within 1 hour of the transaction payment will be deemed as zero.False claims will has legal consiquences.</p> */}
                                                  <div className="payment-box-deposit">
                                                    {xoroData.payment_mode[
                                                      this.state.curPaymentType
                                                    ].map((po, i) => {
                                                      return (
                                                        <>

                                                          <div className="payments-data__group">
                                                            <label className="payments-data__label" >Support Number 1:</label>
                                                            <label className="payments-data__field" >{po.support_number1} <i className="fa fa-clone" title="click to copy" alt="click to copy" aria-hidden="true" onClick={() => this.copyToClipboard(po.support_number1)}></i></label>
                                                            {/* <input className="payments-data__field" id="payments-data-01" type="text"  value={this.state.curAccount.name}/> */}
                                                          </div>
                                                          <div className="payments-data__group">
                                                            <label className="payments-data__label" >Support Number 2:</label>
                                                            <label className="payments-data__field" >{po.support_number2} <i className="fa fa-clone" title="click to copy" alt="click to copy" aria-hidden="true" onClick={() => this.copyToClipboard(po.support_number2)}></i></label>
                                                            {/* <input className="payments-data__field" id="payments-data-01" type="text"  value={this.state.curAccount.name}/> */}
                                                          </div>
                                                        </>
                                                      )
                                                    })}
                                                    <div className="payments-help">
                                                      <span className="payments-help__icon">
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                      </span>
                                                      <div className="payments-help__body">
                                                        <p className="payments-help__text">For more information call on above number.</p>
                                                      </div>
                                                    </div>
                                                  </div>


                                                  <div className="payment-box-deposit payment-box-deposit-seccess">
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Amount:</label>
                                                      <input className="payments-data__field" placeholder="Enter Your Amount Here" id="payments-data-01" type="number" value={this.state.xoroAmount} onChange={(e) => { this.setState({ xoroAmount: e.target.value, }); }} onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }} />
                                                    </div>
                                                  </div>
                                                  
                                                  {DepositBonusOffers && !!this.state.availableBonusOffers &&
                                                    <>
                                                      <div className="col-12 bonus-strip">
                                                        <label htmlFor="userId" className="uname mb-1" data-icon="u">
                                                          Available Offer:
                                                        </label>
                                                        <div className="d-flex justify-content-between mb-3">
                                                          <label className="" onClick={() => { this.onBonusOfferClick() }}>
                                                            <input className="" checked={this.state.bonusOfferApplied ? 'checked' : ''} type="checkbox" /> <span className="">Deposit Bonus {this.state.availableBonusOffers} %</span>
                                                          </label>

                                                          <a className="bonus-strip-a" onClick={()=> this.onBonusDetailsViewMore()}>Bonus Details</a>
                                                        </div>
                                                      </div>
                                                    </>
                                                  }
                                                  <div className="col-12 col-sm-12 col-md-12">
                                                    <div className="form-group pull-right mb-1">
                                                      <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.submitPayment(); }} >
                                                        {this.state.buttonLoader &&
                                                          <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                          </svg>}
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                  {/* 
                                              <div className="col-12 col-sm-6 col-md-6">
                                                <div className="form-group">
                                                  <label htmlFor="email">
                                                    UserName:
                                                  </label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="UserName"
                                                    value={this.state.userId}
                                                    disabled
                                                  />
                                                </div>
                                              </div> */}
                                                  {/* <div className="col-12 col-sm-6 col-md-6">
                                                <div className="form-group">
                                                  <label htmlFor="email">
                                                    Amount:
                                                  </label>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Amount"
                                                    value={this.state.xoroAmount}
                                                    onChange={(e) => {
                                                      this.setState({
                                                        xoroAmount:
                                                          e.target.value,
                                                      });
                                                    }}
                                                  />
                                                </div>
                                              </div> */}
                                                  {/* <div className="col-12 col-sm-6 col-md-6">
                                                <div className="form-group">
                                                  <label htmlFor="email">
                                                    UTR No:
                                                  </label>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter UTR No"
                                                    value={this.state.utr}
                                                    onChange={(e) => {
                                                      this.setState({
                                                        utr: e.target.value,
                                                      });
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-12 col-sm-6 col-md-6">
                                                <div className="form-group">
                                                  <label htmlFor="file">
                                                    Upload Screenshot :
                                                  </label>
                                                  <input
                                                    type="file"
                                                    className="form-control-file"
                                                    id="exampleFormControlFile1"
                                                    accept="image/*"
                                                    onChange={this.selectFile}
                                                  />
                                                </div>
                                              </div> */}
                                                  {/* <div className="col-12 col-sm-6 col-md-6">
                                                <div className="form-group">
                                                  <button
                                                    className="btn place-bet-btn"
                                                    disabled={
                                                      this.state.buttonLoader
                                                    }
                                                    onClick={() => {
                                                      this.submitPayment();
                                                    }}
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}

                                      {/* MQR DESIGN
                                  {(this.state.curPaymentType === "mqr") && (
                                      <> 
                                        {!!this.state.mqrImgDt ? 
                                          <>
                                          <div className="row manual-container-qr">
                                            
                                              <div className={`col-12 col-sm-12 col-md-12`}>
                                                <div className="">
                                                  
                                                    <div className="payment-methods__form-head">
                                                      <span className="payment-methods__form-head-title UPI-title">
                                                        Scan the QR code to pay
                                                      </span>
                                                    </div>
                                                  
                                                
                                                    <div className="manual-deposit-QR">
                                                      <img
                                                        style={{height: "250px"}}
                                                        src={`${this.state.mqrImgDt}`}
                                                        alt=""
                                                      />{" "}
                                                    </div>
                                                    </div>
                                                    </div>

                                                    <div className="col-12 col-sm-12 col-md-12">
                                                    <div className="form-group pull-right mb-1">
                                                      <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.mqrSubmitSecondPayment(); }} >
                                                        {this.state.buttonLoader &&
                                                          <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                          </svg>}
                                                        Done
                                                      </button>
                                                    </div>
                                                  </div>

                                                    </div>  
                                          </>
                                        :
                                        <div className="container">
                                          <div className="row">
                                            <div className="col-12 col-sm-12 col-md-12">
                                              <div
                                                className="btn-group mb-2 deposit-withdrowal-btn-box br5"
                                                role="group"
                                                aria-label="Basic example"
                                              >
                                                {xoroData.payment_mode[
                                                  this.state.curPaymentType
                                                ].map((acc) => {
                                                  return (
                                                    <button
                                                      type="button"
                                                      onClick={() => {
                                                        this.setState({
                                                          curAccount: acc,
                                                          xoroAmount: '',
                                                          ss: {},
                                                          utr: "",
                                                        });
                                                        document.querySelector(
                                                          "#exampleFormControlFile1"
                                                        ).value = null;
                                                      }}
                                                      className={
                                                        acc.name ===
                                                          this.state.curAccount.name
                                                          ? "btn btn-deposit active"
                                                          : "btn btn-deposit"
                                                      }
                                                    >
                                                      {acc.name}
                                                    </button>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="row manual-container-qr">
                                            <>
                                              <div className={`col-12 ${this.state.curPaymentType !== "upi" ? 'col-sm-6 col-md-4' : 'col-sm-12 col-md-12'}`}>
                                                <div className="">
                                                  {this.state.curPaymentType !== "upi" &&
                                                    <div className="manual-deposit-QR">
                                                      <img
                                                        src={`${this.state.curAccount.qr_code}?${new Date().getTime()}`}
                                                        alt=""
                                                      />{" "}
                                                    </div>
                                                  }
                                                  <div className="manual-min-max text-right w-100" >
                                                    <span className="mr-2">
                                                      Min:
                                                      {
                                                        this.state.curAccount
                                                          .min_limit
                                                      }
                                                    </span>
                                                    <span>
                                                      Max:
                                                      {
                                                        this.state.curAccount
                                                          .max_limit
                                                      }
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className={`col-12 ${this.state.curPaymentType !== "upi" ? 'col-sm-6 col-md-8' : 'col-sm-12 col-md-12'}`}>
                                                <div className="row transfernote ">

                                                  <div className="payment-box-deposit">
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Account Name:</label>
                                                      <label className="payments-data__field" >{this.state.curAccount.name}</label>
                                                    </div>
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Wallet:</label>
                                                      <label className="payments-data__field" >{this.state.curAccount.upi_id} <i className="fa fa-clone" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.state.curAccount.upi_id)}></i></label>
                                                    </div>
                                                    <div className="payments-help">
                                                      <span className="payments-help__icon">
                                                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                      </span>
                                                      <div className="payments-help__body">
                                                        <p className="payments-help__text">If your amount is greater than 100,000 than click <button className="" onClick={()=>{this.goOutOfMQR()}}>here</button> </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="payment-box-deposit payment-box-deposit-seccess">
                                                    <div className="payments-data__group">
                                                      <label className="payments-data__label" >Amount:</label>
                                                      <input className="payments-data__field" placeholder="Enter Your Amount Here" id="payments-data-01" type="number" value={this.state.xoroAmount} onChange={(e) => { this.setState({ xoroAmount: e.target.value, }); }} />
                                                    </div>
                                                  </div>
                                                  <div className="col-12 col-sm-12 col-md-12">
                                                    <div className="form-group pull-right mb-1">
                                                      <button className="btn place-bet-btn " disabled={this.state.buttonLoader} onClick={() => { this.mqrSubmitFirstPayment(); }} >
                                                        {this.state.buttonLoader &&
                                                          <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                          </svg>}
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          </div>
                                        </div>
                                        }
                                      </>
                                    )} */}

                                      {['rdr'].includes(OPERATOR_ID.toLowerCase()) &&
                                        <div className="container mt-whatsapp-5">
                                          <div className="row">
                                            <div className="col-12 payment-box-deposit-seccess-whatsapp">
                                              <span className="whats-app-color-deposit"><i className="fa fa-whatsapp mr-1 f-15" aria-hidden="true"></i><a href={(SOCIALMEDIALINKS.whatsapp.includes(',') ? SOCIALMEDIALINKS.whatsapp.split(',')[0] : SOCIALMEDIALINKS.whatsapp)}>{(SOCIALMEDIALINKS.whatsappDisplayNumber.includes(',') ? SOCIALMEDIALINKS.whatsappDisplayNumber.split(',')[0] : SOCIALMEDIALINKS.whatsappDisplayNumber)}</a></span>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                          }
                        </>
                      )}
                    </>
                  )}
                  {/* END MANUAL DEPOSIT POPUP  */}
                  {this.state.depositSelected === -1 && (
                    <>
                      <div className="manualdepositbox ">
                        <div className="payment-modal__inner">
                          <div className="payment-methods">
                            <div className="payment-methods__list payment-methods__scrollable">
                              <div className="mobile-manual">
                                {this.state.xoroDataWithDrawal.length > 0 && this.state.xoroDataWithDrawal.map((itm, index) => {
                                  return (
                                    <div
                                      onClick={() => {
                                        this.setState({ currentWithdrawalType: itm });
                                      }}
                                      className={`payment-method ${this.state.currentWithdrawalType === itm ? 'active' : ''}`}
                                    >
                                      <img
                                        src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/depositicon/${pymnttypeimg[itm.toLowerCase()]}`}
                                        alt={`${itm} Logo`}
                                        className="payment-method-logo"
                                      />
                                      <div className="payment-method__middle">
                                        <span className="payment-method-name text-transform-capitalize">
                                          {itm}
                                        </span>
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                            <div className="payment-methods__detail-form payment-methods__scrollable">
                              <div className="container">
                                <div className="row manual-container-qr m-0">
                                  <div className="col-12 col-sm-12 col-md-12">
                                    <div className="row transfernote ">
                                      <div className="payment-box-deposit">
                                        {WithdrawPreviousBank && this.state.currentWithdrawalType === 'bank' && !!this.state.previousBankDetails && this.state.previousBankDetails.length > 0 && <WithdrawBankDropdownMenu array={this.state.previousBankDetails} onUsePreviousBankClick={(itmm)=> this.onUsePreviousBankClick(itmm)} deletePreviousBank={(itmm)=> this.deletePreviousBank(itmm)} previousBankDetailsBtnLdr={this.state.previousBankDetailsBtnLdr}></WithdrawBankDropdownMenu>}
                                        <div className="payments-data__group">
                                          <label className="payments-data__label">{this.state.currentWithdrawalType === 'bank' ? 'Account Holder Name' : 'Holder Name'}</label>
                                          <input id="accountHolderName" className="payments-data__field" name="accountHolderName" type="text" value={this.state.accountHolderName} onChange={(e) => this.onChange(e)} placeholder="Enter Account Holder Name"  ></input>
                                        </div>
                                        <div className="payments-data__group">
                                          <label className="payments-data__label">{this.state.currentWithdrawalType === 'bank' ? 'Account Number' : 'Wallet ID/Number'}</label>
                                          {this.state.currentWithdrawalType === 'bank' ?
                                            <input id="accountNumber" className="payments-data__field" name="accountNumber" type="number" value={this.state.accountNumber} onChange={(e) => this.onChange(e)} placeholder="Enter Account Number"></input>
                                            :
                                            <input id="accountNumber" className="payments-data__field" name="accountNumber" type="text" value={this.state.accountNumber} onChange={(e) => this.onChange(e)} placeholder="Enter Wallet ID/Number"></input>
                                          }
                                        </div>
                                        {this.state.currentWithdrawalType === 'bank' &&
                                          <>
                                            <div className="payments-data__group">

                                              <>
                                                <label className="payments-data__label"> IFSC Code</label>
                                                <input id="iFSCCode"
                                                  className="payments-data__field text-uppercase"
                                                  name="iFSCCode"
                                                  type="text"
                                                  value={this.state.iFSCCode}
                                                  onChange={(e) => this.onChange(e)}
                                                  onBlur={()=> this.onIFSCBlur()}
                                                  placeholder="Enter iFSCCode"  ></input>
                                              </>
                                            </div>
                                            {!!this.state.ifscBankDetails && Object.keys(this.state.ifscBankDetails).length > 0 &&
                                              <label className="ifsc-bank-details">{this.state.ifscBankDetails.BANK}-{this.state.ifscBankDetails.BRANCH}-{this.state.ifscBankDetails.DISTRICT}</label>
                                            }
                                          </>
                                        }
                                        <div className="payments-data__group">
                                          <label className="payments-data__label">Amount</label>
                                          <input id="amount" className="payments-data__field" name="amount" type="number" value={this.state.amount} onChange={(e) => this.onChange(e)} onWheel={(e) => e.target.blur()} placeholder="Enter Amount" onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}></input>
                                          {/* {!!this.state.amount &&
                                            this.state.amount < MINIMUM_WITHDRAW ? (
                                            <label
                                              className="signup-validation-text"
                                              style={{ color: "red" }}
                                            >
                                              Minimum withdrawal amount is {MINIMUM_WITHDRAW}.
                                            </label>
                                          ) : (
                                            !!this.state.amount &&
                                            (parseFloat(this.state.amount) >
                                              parseFloat(this.state.balance) ? (
                                              <label
                                                className="signup-validation-text"
                                                style={{ color: "red" }}
                                              >
                                                Withdrawal amount cannot be greater the
                                                balance.
                                              </label>
                                            ) : null)
                                          )} */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="col-12 col-sm-12 col-md-12">
                                      <div className="form-group">
                                        <label className="form--title">
                                        {this.state.currentWithdrawalType === 'bank' ? 'Account Holder Name' : 'Holder Name'}
                                          </label>
                                    <input id="accountHolderName" className="form-control text-capitalize" name="accountHolderName" type="text"  value={this.state.accountHolderName} onChange={(e) => this.onChange(e)}  ></input>
                                    </div>
                                    </div> */}
                                  {/* <div className="col-12 col-sm-12 col-md-12">
                                        <div className="form-group">
                                          <label className="form--title">
                                          {this.state.currentWithdrawalType === 'bank' ? 'Account Number' : 'Wallet ID/Number'}
                                          </label>
                                          <input id="accountNumber" className="form-control" name="accountNumber" type="number" value={this.state.accountNumber} onChange={(e) => this.onChange(e)}  ></input>
                                        </div>
                                    </div> */}
                                  {/* <div className="col-12 col-sm-12 col-md-12">
                                      
                                      {this.state.currentWithdrawalType === 'bank' && 
                                        <div className="form-group">
                                          <label className="form--title">
                                            IFSC Code
                                          </label>
                                          <input
                                            id="iFSCCode"
                                            className="form-control text-uppercase"
                                            name="iFSCCode"
                                            type="text"
                                            value={this.state.iFSCCode}
                                            onChange={(e) => this.onChange(e)}
                                          ></input>
                                        </div>
                                      }
                                    </div> */}
                                  {/* <div className="col-12 col-sm-12 col-md-12">
                                        <div className="form-group">
                                  <label className="form--title">Amount</label>
                                  <input id="amount" className="form-control" name="amount" type="number" value={this.state.amount} onChange={(e) => this.onChange(e)} onWheel={(e) => e.target.blur()}  ></input>
                                  {!!this.state.amount &&
                                    this.state.amount < MINIMUM_WITHDRAW ? (
                                    <label
                                      className="signup-validation-text"
                                      style={{ color: "red" }}
                                    >
                                      Minimum withdrawal amount is {MINIMUM_WITHDRAW}.
                                    </label>
                                  ) : (
                                    !!this.state.amount &&
                                    (parseFloat(this.state.amount) >
                                      parseFloat(this.state.balance) ? (
                                      <label
                                        className="signup-validation-text"
                                        style={{ color: "red" }}
                                      >
                                        Withdrawal amount cannot be greater the
                                        balance.
                                      </label>
                                    ) : null)
                                  )}
                                        </div>
                                    </div> */}
                                  <div className="col-12 col-sm-12 col-md-12">
                                    <div className="form-group">
                                      {/* <button id="btnWithdraw" className="btn-type-submit w-auto" disabled={this.validateWithdrawalForm()} onClick={() => this.onWithdrawalClick()}  > */}
                                      <button id="btnWithdraw" className="btn-type-submit w-auto" onClick={() => this.onWithdrawalClick()}  >
                                        Withdraw
                                      </button>
                                      {/* {this.state.currentWithdrawalType === 'bank' && !!this.state.previousBankDetails && 
                                        <button id="btnUsePreviousBank" className="btn-type-submit w-auto mr-3" onClick={() => this.onUsePreviousBankClick()}  >
                                          Use Previous Bank
                                        </button>
                                      } */}
                                    </div>
                                  </div>




                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="depositboxview">
                        <div className="payment-methods__detail-form payment-methods__scrollable w-100">
                          <div className="payment-methods__form-head d-block">
                            <div className="form-group">
                              <label className="form--title">
                              {this.state.currentWithdrawalType === 'bank' ? 'Account Holder Name' : 'Holder Name'}
                                
                              </label>
                              <input
                                id="accountHolderName"
                                className="form-control text-capitalize"
                                name="accountHolderName"
                                type="text"
                                value={this.state.accountHolderName}
                                onChange={(e) => this.onChange(e)}
                              ></input>
                            </div>
                            <div className="form-group">
                              <label className="form--title">
                              {this.state.currentWithdrawalType === 'bank' ? 'Account Number' : 'Wallet ID/Number'}
                              </label>
                              <input
                                id="accountNumber"
                                className="form-control"
                                name="accountNumber"
                                type="number"
                                value={this.state.accountNumber}
                                onChange={(e) => this.onChange(e)}
                              ></input>
                            </div>
                            {this.state.currentWithdrawalType === 'bank' && 
                              <div className="form-group">
                                <label className="form--title">
                                  IFSC Code
                                </label>
                                <input
                                  id="iFSCCode"
                                  className="form-control text-uppercase"
                                  name="iFSCCode"
                                  type="text"
                                  value={this.state.iFSCCode}
                                  onChange={(e) => this.onChange(e)}
                                ></input>
                              </div>
                            }
                            <div className="form-group">
                              <label className="form--title">Amount</label>
                              {/* <label className='float-right'><small>Current Balance:</small> <b>{this.state.balance}</b></label> *}
                              <input
                                id="amount"
                                className="form-control"
                                name="amount"
                                type="number"
                                value={this.state.amount}
                                onChange={(e) => this.onChange(e)}
                                onWheel={(e) => e.target.blur()}
                              ></input>
                              {!!this.state.amount &&
                                this.state.amount < MINIMUM_WITHDRAW ? (
                                <label
                                  className="signup-validation-text"
                                  style={{ color: "red" }}
                                >
                                  Minimum withdrawal amount is {MINIMUM_WITHDRAW}.
                                </label>
                              ) : (
                                !!this.state.amount &&
                                (parseFloat(this.state.amount) >
                                  parseFloat(this.state.balance) ? (
                                  <label
                                    className="signup-validation-text"
                                    style={{ color: "red" }}
                                  >
                                    Withdrawal amount cannot be greater the
                                    balance.
                                  </label>
                                ) : null)
                              )}
                            </div>
                            <div className="form-group">
                              <button
                                id="btnWithdraw"
                                className="btn-type-submit"
                                disabled={this.validateWithdrawalForm()}
                                onClick={() => this.onWithdrawalClick()}
                              >
                                Withdraw
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </>
                  )}
                </div>

                {/*END AMOUNT ADD WALLET DEPOSIT POPUP */}
              </div>
            </>
            }
          </div>
          <div className="modal-backdrop fade show"></div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(Depositpopup);
